// // import { useState } from 'react';
// // import { Link, useNavigate } from 'react-router-dom';

// // /*
// //   Pixel-exact hero: the design image is the background, and real working
// //   controls (search, location, job type, buttons, links, chat input) sit on top.

// //   Put  hero-full.webp  in your  /public  folder.
// //   Image size is 1672 x 841, positions below are in those pixels.
// // */

// // const W = 1672;
// // const H = 841;

// // // convert image pixels -> percentage box
// // const box = (x1, y1, x2, y2) => ({
// //   left: `${(x1 / W) * 100}%`,
// //   top: `${(y1 / H) * 100}%`,
// //   width: `${((x2 - x1) / W) * 100}%`,
// //   height: `${((y2 - y1) / H) * 100}%`,
// // });

// // const ASSIST = [
// //   { label: 'Find a job for me', y: 400 },
// //   { label: 'Improve my resume', y: 440 },
// //   { label: 'Explore career options', y: 480 },
// //   { label: 'Tell me about this job', y: 520 },
// // ];

// // export default function HeroSection({
// //   keyword, setKeyword, location, setLocation, jobType, setJobType, onSearch, onOpenAssistant,
// // }) {
// //   const navigate = useNavigate();
// //   const [ask, setAsk] = useState('');

// //   const openAssistant = (text) => {
// //     if (onOpenAssistant) onOpenAssistant(text);
// //     else navigate('/jobs');
// //   };

// //   return (
// //     <section className="hx2-scroll" aria-label="Find your next move">
// //       <style>{css}</style>

// //       {/* real text for search engines and screen readers */}
// //       <h1 className="hx2-sr">Find Your Next Move. Build Your Future.</h1>
// //       <p className="hx2-sr">
// //         Explore thousands of career possibilities, discover jobs matching your skills and connect with employers
// //         looking for talent like you.
// //       </p>

// //       <div className="hx2-stage">
// //         <img className="hx2-bg" src="/hero-full.webp" alt="" draggable="false" />

// //         {/* badge */}
// //         <Link to="/jobs" className="hx2-hit" style={box(60, 38, 440, 90)} aria-label="Explore jobs in 500+ companies" />

// //         {/* job cards: Apply Now */}
// //         <Link to="/jobs" className="hx2-hit" style={box(758, 296, 866, 328)} aria-label="Apply to Product Manager at Microsoft" />
// //         <Link to="/jobs" className="hx2-hit" style={box(917, 272, 1097, 318)} aria-label="Apply to Software Engineer at Google" />
// //         <Link to="/jobs" className="hx2-hit" style={box(1160, 284, 1270, 318)} aria-label="Apply to System Analyst at TCS" />

// //         {/* search bar */}
// //         <form onSubmit={onSearch}>
// //           <input
// //             className="hx2-in" style={box(122, 520, 402, 558)}
// //             value={keyword} onChange={(e) => setKeyword(e.target.value)}
// //             placeholder="Search jobs, skills, or companies..." aria-label="Search jobs, skills, or companies"
// //           />
// //           <input
// //             className="hx2-in" style={box(462, 520, 534, 558)}
// //             value={location} onChange={(e) => setLocation(e.target.value)}
// //             placeholder="Location" aria-label="Location"
// //           />
// //           <select
// //             className="hx2-in hx2-sel" style={box(620, 520, 698, 558)}
// //             value={jobType} onChange={(e) => setJobType(e.target.value)} aria-label="Job type"
// //           >
// //             <option value="">Job Type</option>
// //             <option value="full_time">Full Time</option>
// //             <option value="part_time">Part Time</option>
// //             <option value="internship">Internship</option>
// //             <option value="contract">Contract</option>
// //           </select>
// //           <button type="submit" className="hx2-hit hx2-pill" style={box(746, 503, 936, 576)} aria-label="Find Jobs" />
// //         </form>

// //         {/* assistant quick actions */}
// //         {ASSIST.map((a) => (
// //           <button
// //             key={a.label} type="button" className="hx2-hit"
// //             style={box(1362, a.y, 1595, a.y + 36)} onClick={() => openAssistant(a.label)} aria-label={a.label}
// //           />
// //         ))}

// //         {/* assistant chat input */}
// //         <input
// //           className="hx2-in" style={box(1376, 570, 1528, 600)}
// //           value={ask} onChange={(e) => setAsk(e.target.value)}
// //           onKeyDown={(e) => { if (e.key === 'Enter') { openAssistant(ask); setAsk(''); } }}
// //           placeholder="Ask something..." aria-label="Ask the PlanB Assistant"
// //         />
// //         <button
// //           type="button" className="hx2-hit hx2-round" style={box(1545, 568, 1588, 608)}
// //           onClick={() => { openAssistant(ask); setAsk(''); }} aria-label="Send"
// //         />
// //       </div>
// //     </section>
// //   );
// // }

// // const css = `
// // .hx2-scroll{background:#050a2e;overflow-x:auto;overflow-y:hidden}
// // .hx2-stage{position:relative;width:100%;min-width:1000px;aspect-ratio:1672/841;container-type:inline-size}
// // .hx2-bg{position:absolute;inset:0;width:100%;height:100%;display:block;user-select:none}
// // .hx2-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap}
// // .hx2-hit{position:absolute;display:block;background:transparent;border:0;padding:0;cursor:pointer;border-radius:12px;transition:background .2s,box-shadow .2s}
// // .hx2-hit:hover{background:rgba(255,255,255,.09)}
// // .hx2-hit:focus-visible,.hx2-in:focus-visible{outline:2px solid #fff;outline-offset:2px}
// // .hx2-pill{border-radius:999px}.hx2-pill:hover{background:rgba(255,255,255,.14);box-shadow:0 0 28px rgba(176,59,255,.7)}
// // .hx2-round{border-radius:50%}
// // .hx2-in{position:absolute;background:transparent;border:0;outline:0;color:#fff;font-family:inherit;font-weight:500;
// //   font-size:.96cqw;padding:0 2px;min-width:0}
// // .hx2-in::placeholder{color:rgba(255,255,255,.78);opacity:1}
// // .hx2-sel{appearance:none;-webkit-appearance:none;cursor:pointer}
// // .hx2-sel option{color:#111;font-size:14px}
// // `;





// // // import { useState, useEffect, useRef } from 'react';
// // // import { Link, useNavigate } from 'react-router-dom';

// // // /*
// // //   Light, premium hero: copy on the left, animated PlanB robot in the middle,
// // //   assistant search card on the right, statistics bar underneath.

// // //   Same props as before, so Home.jsx does not need to change:
// // //     keyword, setKeyword, location, setLocation, jobType, setJobType, onSearch, onOpenAssistant
// // //   Optional extras: employerLink, stats

// // //   No images or extra packages needed: the robot is an inline animated SVG
// // //   and every animation is plain CSS.
// // // */

// // // // EDIT ME: these four numbers are placeholders taken from the design mock-up.
// // // // Replace them with your real figures (or pass a `stats` prop from Home.jsx).
// // // const HERO_STATS = [
// // //   { key: 'seekers', icon: 'users', end: 1, suffix: 'M+', label: 'Job Seekers' },
// // //   { key: 'employers', icon: 'building', end: 50, suffix: 'K+', label: 'Employers' },
// // //   { key: 'rating', icon: 'star', end: 4.8, decimals: 1, suffix: '/5', label: 'User Rating' },
// // //   { key: 'faster', icon: 'bolt', end: 10, suffix: 'x', label: 'Faster Hiring' },
// // // ];
// // // const TRUSTED_LABEL = ['Trusted by', 'Millions'];

// // // const POPULAR = [
// // //   { label: 'Software Engineer' },
// // //   { label: 'Data Scientist' },
// // //   { label: 'Product Manager' },
// // //   { label: 'Remote Jobs', to: '/jobs?work_mode=work_from_home' },
// // //   { label: 'Full Stack Developer' },
// // //   { label: 'Marketing' },
// // // ];

// // // const ASSISTANT_ACTIONS = ['Find a job for me', 'Improve my resume', 'Explore career options', 'Tell me about this job'];

// // // const RESOURCES = [
// // //   { label: 'Free mock interview', to: '/#mock-interview' },
// // //   { label: 'Why PlanB Jobs', to: '/#why-planb' },
// // //   { label: 'Browse industries', to: '/#industries' },
// // //   { label: 'Jobs by career stage', to: '/#career-stage' },
// // //   { label: 'FAQs', to: '/#faq' },
// // // ];

// // // /* ------------------------------ icons ------------------------------ */
// // // const ICONS = {
// // //   search: <><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></>,
// // //   arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
// // //   briefcase: <><rect x="2" y="7" width="20" height="13" rx="2" /><path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2M2 12h20" /></>,
// // //   building: <><rect x="4" y="3" width="10" height="18" /><rect x="14" y="9" width="6" height="12" /><path d="M7 7h1M11 7h1M7 11h1M11 11h1M7 15h1M11 15h1" /></>,
// // //   book: <><path d="M2 5a2 2 0 012-2h6a2 2 0 012 2v15a2 2 0 00-2-2H2z" /><path d="M22 5a2 2 0 00-2-2h-6a2 2 0 00-2 2v15a2 2 0 012-2h8z" /></>,
// // //   bolt: <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" />,
// // //   users: <><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6" /><circle cx="17.5" cy="9" r="2.5" /><path d="M17 14c2.6.2 4.5 2 4.5 5" /></>,
// // //   star: <path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.1 1.2-6.5L2.5 9.4l6.6-.9L12 2.5z" />,
// // //   send: <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />,
// // //   chat: <path d="M21 11.5a8.4 8.4 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.4 8.4 0 01-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.4 8.4 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />,
// // //   person: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" /></>,
// // // };

// // // function Icon({ name, className = '', fill = 'none', strokeWidth = 2 }) {
// // //   return (
// // //     <svg viewBox="0 0 24 24" fill={fill} stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
// // //       {ICONS[name]}
// // //     </svg>
// // //   );
// // // }

// // // /* --------------------------- count-up number --------------------------- */
// // // function CountUp({ end, decimals = 0, suffix = '' }) {
// // //   const ref = useRef(null);
// // //   const [val, setVal] = useState(0);

// // //   useEffect(() => {
// // //     const el = ref.current;
// // //     if (!el) return undefined;
// // //     const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
// // //     if (reduce || !('IntersectionObserver' in window)) { setVal(end); return undefined; }
// // //     let raf;
// // //     const io = new IntersectionObserver(([entry]) => {
// // //       if (!entry.isIntersecting) return;
// // //       io.disconnect();
// // //       const start = performance.now();
// // //       const dur = 1400;
// // //       const tick = (t) => {
// // //         const p = Math.min(1, (t - start) / dur);
// // //         setVal(end * (1 - Math.pow(1 - p, 3)));
// // //         if (p < 1) raf = requestAnimationFrame(tick);
// // //       };
// // //       raf = requestAnimationFrame(tick);
// // //     }, { threshold: 0.4 });
// // //     io.observe(el);
// // //     return () => { io.disconnect(); cancelAnimationFrame(raf); };
// // //   }, [end]);

// // //   return <span ref={ref}>{val.toFixed(decimals)}{suffix}</span>;
// // // }

// // // /* ------------------------------ the robot ------------------------------ */
// // // function Robot() {
// // //   return (
// // //     <svg viewBox="0 0 300 390" className="hx-robot-svg" role="img" aria-label="PlanB AI assistant robot waving hello">
// // //       <defs>
// // //         <linearGradient id="hxBody" x1="0" y1="0" x2="0" y2="1">
// // //           <stop offset="0" stopColor="#FFFFFF" />
// // //           <stop offset="1" stopColor="#E8E1F7" />
// // //         </linearGradient>
// // //         <linearGradient id="hxPurple" x1="0" y1="0" x2="1" y2="1">
// // //           <stop offset="0" stopColor="#743BFF" />
// // //           <stop offset="1" stopColor="#E83FAF" />
// // //         </linearGradient>
// // //         <radialGradient id="hxScreen" cx=".5" cy=".35" r=".9">
// // //           <stop offset="0" stopColor="#1C2352" />
// // //           <stop offset="1" stopColor="#05071C" />
// // //         </radialGradient>
// // //         <filter id="hxGlow" x="-30%" y="-30%" width="160%" height="160%">
// // //           <feGaussianBlur stdDeviation="2.6" result="b" />
// // //           <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
// // //         </filter>
// // //       </defs>

// // //       <ellipse className="hx-shadow" cx="150" cy="372" rx="84" ry="10" fill="#743BFF" opacity=".18" />

// // //       <g className="hx-float">
// // //         {/* legs and feet */}
// // //         <rect x="116" y="276" width="30" height="66" rx="15" fill="url(#hxBody)" stroke="#D9D0F2" strokeWidth="2" />
// // //         <rect x="154" y="276" width="30" height="66" rx="15" fill="url(#hxBody)" stroke="#D9D0F2" strokeWidth="2" />
// // //         <rect x="100" y="336" width="52" height="26" rx="13" fill="#FFFFFF" stroke="#D9D0F2" strokeWidth="2" />
// // //         <rect x="100" y="354" width="52" height="8" rx="4" fill="#2A2F5C" />
// // //         <rect x="148" y="336" width="52" height="26" rx="13" fill="#FFFFFF" stroke="#D9D0F2" strokeWidth="2" />
// // //         <rect x="148" y="354" width="52" height="8" rx="4" fill="#2A2F5C" />

// // //         {/* neck and body */}
// // //         <rect x="136" y="176" width="28" height="30" rx="8" fill="#CFC6EA" />
// // //         <rect x="98" y="196" width="104" height="94" rx="40" fill="url(#hxBody)" stroke="#D9D0F2" strokeWidth="2" />
// // //         <circle cx="150" cy="244" r="21" fill="url(#hxPurple)" />
// // //         <text x="150" y="252" textAnchor="middle" fontSize="24" fontWeight="800" fill="#FFFFFF" fontFamily="Inter, system-ui, sans-serif">B</text>

// // //         {/* resting arm */}
// // //         <g transform="rotate(-10 212 216)">
// // //           <rect x="200" y="212" width="24" height="70" rx="12" fill="url(#hxBody)" stroke="#D9D0F2" strokeWidth="2" />
// // //           <circle cx="212" cy="288" r="13" fill="#FFFFFF" stroke="#D9D0F2" strokeWidth="2" />
// // //         </g>

// // //         {/* waving arm */}
// // //         <g className="hx-wave">
// // //           <rect x="78" y="146" width="24" height="76" rx="12" fill="url(#hxBody)" stroke="#D9D0F2" strokeWidth="2" />
// // //           <circle cx="90" cy="140" r="15" fill="#FFFFFF" stroke="#D9D0F2" strokeWidth="2" />
// // //           <ellipse cx="74" cy="146" rx="6" ry="10" transform="rotate(-25 74 146)" fill="#FFFFFF" stroke="#D9D0F2" strokeWidth="2" />
// // //         </g>
// // //         <g className="hx-spark" stroke="#743BFF" strokeWidth="3" strokeLinecap="round">
// // //           <path d="M62 112l-9-10" /><path d="M76 104l-3-13" /><path d="M92 102l4-13" />
// // //         </g>

// // //         {/* head */}
// // //         <g className="hx-head">
// // //           <line x1="150" y1="62" x2="150" y2="44" stroke="#CFC6EA" strokeWidth="4" strokeLinecap="round" />
// // //           <circle className="hx-antenna" cx="150" cy="40" r="6" fill="url(#hxPurple)" />
// // //           <circle cx="84" cy="126" r="21" fill="url(#hxPurple)" />
// // //           <circle cx="84" cy="126" r="9" fill="#FFFFFF" opacity=".25" />
// // //           <circle cx="216" cy="126" r="21" fill="url(#hxPurple)" />
// // //           <circle cx="216" cy="126" r="10" fill="none" stroke="#3DE6FF" strokeWidth="4" />
// // //           <rect x="90" y="62" width="120" height="112" rx="48" fill="url(#hxBody)" stroke="#D9D0F2" strokeWidth="2" />
// // //           <path d="M108 84q10-10 28-12" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" fill="none" opacity=".8" />
// // //           <rect x="103" y="76" width="94" height="78" rx="32" fill="url(#hxScreen)" />
// // //           <g className="hx-eyes" filter="url(#hxGlow)" stroke="#36E3FF" strokeWidth="6" strokeLinecap="round" fill="none">
// // //             <path d="M121 112q11-16 22 0" />
// // //             <path d="M157 112q11-16 22 0" />
// // //           </g>
// // //           <path d="M138 132q12 12 24 0" stroke="#36E3FF" strokeWidth="5" strokeLinecap="round" fill="none" filter="url(#hxGlow)" />
// // //           <circle cx="116" cy="130" r="5" fill="#E83FAF" opacity=".35" />
// // //           <circle cx="184" cy="130" r="5" fill="#E83FAF" opacity=".35" />
// // //         </g>
// // //       </g>
// // //     </svg>
// // //   );
// // // }

// // // /* ------------------------------- component ------------------------------- */
// // // export default function HeroSection({
// // //   keyword, setKeyword, location, setLocation, jobType, setJobType, onSearch, onOpenAssistant,
// // //   employerLink, stats,
// // // }) {
// // //   const navigate = useNavigate();
// // //   const [tab, setTab] = useState('jobs');
// // //   const [showFilters, setShowFilters] = useState(false);
// // //   const [company, setCompany] = useState('');
// // //   const [ask, setAsk] = useState('');

// // //   const isLoggedIn = !!localStorage.getItem('token');
// // //   const hireLink = employerLink || (isLoggedIn ? '/employer/jobs' : '/register');
// // //   const statList = Array.isArray(stats) && stats.length ? stats : HERO_STATS;

// // //   const openAssistant = (text) => {
// // //     if (onOpenAssistant) onOpenAssistant(text);
// // //     else navigate('/jobs');
// // //   };

// // //   const goPopular = (p) => {
// // //     if (p.to) { navigate(p.to); return; }
// // //     setKeyword(p.label);
// // //     navigate(`/jobs?keyword=${encodeURIComponent(p.label)}`);
// // //   };

// // //   const searchCompanies = (e) => {
// // //     e.preventDefault();
// // //     const q = company.trim();
// // //     navigate(q ? `/jobs?keyword=${encodeURIComponent(q)}` : '/jobs');
// // //   };

// // //   const sendAsk = (e) => {
// // //     e.preventDefault();
// // //     openAssistant(ask.trim());
// // //     setAsk('');
// // //   };

// // //   const tabs = [
// // //     { key: 'jobs', label: 'Jobs', icon: 'briefcase' },
// // //     { key: 'employers', label: 'Employers', icon: 'building' },
// // //     { key: 'resources', label: 'Resources', icon: 'book' },
// // //   ];

// // //   return (
// // //     <section className="hx" aria-label="Find your next move">
// // //       <style>{css}</style>

// // //       <div className="hx-blob hx-blob-a" aria-hidden="true" />
// // //       <div className="hx-blob hx-blob-b" aria-hidden="true" />
// // //       <div className="hx-dots" aria-hidden="true" />

// // //       <div className="hx-wrap">
// // //         <div className="hx-grid">
// // //           {/* ------------------------------ copy ------------------------------ */}
// // //           <div className="hx-copy">
// // //             <span className="hx-badge hx-up" style={{ animationDelay: '.05s' }}>
// // //               <Icon name="bolt" className="hx-badge-ic" fill="currentColor" strokeWidth={1.5} />
// // //               Smarter Jobs. Brighter Future.
// // //             </span>

// // //             <h1 className="hx-h1 hx-up" style={{ animationDelay: '.15s' }}>
// // //               Find Your Next Move.<br />
// // //               Build Your <span className="hx-grad">Future.</span>
// // //               <svg className="hx-swoosh" viewBox="0 0 220 14" aria-hidden="true">
// // //                 <defs>
// // //                   <linearGradient id="hxSw" x1="0" x2="1"><stop offset="0" stopColor="#743BFF" /><stop offset="1" stopColor="#E83FAF" /></linearGradient>
// // //                 </defs>
// // //                 <path d="M4 9C50 2 130 2 216 8" stroke="url(#hxSw)" strokeWidth="4" strokeLinecap="round" fill="none" />
// // //               </svg>
// // //             </h1>

// // //             <p className="hx-p hx-up" style={{ animationDelay: '.28s' }}>
// // //               Your next opportunity could be closer than you think. Explore thousands of career possibilities,
// // //               discover jobs matching your skills and connect with employers looking for talent like you.
// // //             </p>

// // //             <div className="hx-cta hx-up" style={{ animationDelay: '.4s' }}>
// // //               <Link to="/jobs" className="hx-btn hx-btn-primary">
// // //                 Find Jobs <Icon name="arrow" className="hx-btn-ic" />
// // //               </Link>
// // //               <Link to={hireLink} className="hx-btn hx-btn-ghost">
// // //                 <Icon name="briefcase" className="hx-btn-ic" /> Hire Talent
// // //               </Link>
// // //             </div>
// // //           </div>

// // //           {/* ------------------------------ robot ------------------------------ */}
// // //           <div className="hx-robot-col">
// // //             <div className="hx-bubble" role="note">
// // //               <strong>Hello! <span aria-hidden="true">👋</span></strong>
// // //               <span>{"Let's find your dream job together!"}</span>
// // //               <i className="hx-bubble-tail" aria-hidden="true" />
// // //               <svg className="hx-bubble-spark" viewBox="0 0 40 30" aria-hidden="true">
// // //                 <g stroke="#743BFF" strokeWidth="3" strokeLinecap="round"><path d="M6 24l8-9" /><path d="M20 12l2-10" /><path d="M32 18l8-4" /></g>
// // //               </svg>
// // //             </div>
// // //             <div className="hx-robot"><Robot /></div>
// // //           </div>

// // //           {/* ----------------------------- assistant card ----------------------------- */}
// // //           <div className="hx-card" aria-live="polite">
// // //             <div className="hx-tabs" role="tablist" aria-label="What to search">
// // //               {tabs.map((t) => (
// // //                 <button
// // //                   key={t.key} type="button" role="tab" aria-selected={tab === t.key}
// // //                   className={`hx-tab ${tab === t.key ? 'is-on' : ''}`} onClick={() => setTab(t.key)}
// // //                 >
// // //                   <Icon name={t.icon} className="hx-tab-ic" /> {t.label}
// // //                 </button>
// // //               ))}
// // //             </div>

// // //             <p className="hx-q">What are you looking for?</p>

// // //             {tab === 'jobs' && (
// // //               <>
// // //                 <form onSubmit={onSearch}>
// // //                   <div className="hx-search">
// // //                     <Icon name="search" className="hx-search-ic" />
// // //                     <input
// // //                       value={keyword} onChange={(e) => setKeyword(e.target.value)}
// // //                       placeholder="Search jobs..." aria-label="Search jobs, skills or companies" autoComplete="off"
// // //                     />
// // //                     <button type="submit" className="hx-go" aria-label="Search jobs"><Icon name="arrow" className="hx-go-ic" /></button>
// // //                   </div>

// // //                   <button type="button" className="hx-more" onClick={() => setShowFilters((v) => !v)} aria-expanded={showFilters}>
// // //                     {showFilters ? '− Hide' : '+ Add'} location and job type
// // //                   </button>
// // //                   {showFilters && (
// // //                     <div className="hx-filters">
// // //                       <input value={location} onChange={(e) => setLocation(e.target.value)} placeholder="Location" aria-label="Location" />
// // //                       <select value={jobType} onChange={(e) => setJobType(e.target.value)} aria-label="Job type">
// // //                         <option value="">Job type</option>
// // //                         <option value="full_time">Full Time</option>
// // //                         <option value="part_time">Part Time</option>
// // //                         <option value="internship">Internship</option>
// // //                         <option value="contract">Contract</option>
// // //                       </select>
// // //                     </div>
// // //                   )}
// // //                 </form>

// // //                 <p className="hx-sub">Popular Searches:</p>
// // //                 <div className="hx-chips">
// // //                   {POPULAR.map((p) => (
// // //                     <button key={p.label} type="button" className="hx-chip" onClick={() => goPopular(p)}>{p.label}</button>
// // //                   ))}
// // //                 </div>
// // //               </>
// // //             )}

// // //             {tab === 'employers' && (
// // //               <>
// // //                 <form onSubmit={searchCompanies}>
// // //                   <div className="hx-search">
// // //                     <Icon name="search" className="hx-search-ic" />
// // //                     <input
// // //                       value={company} onChange={(e) => setCompany(e.target.value)}
// // //                       placeholder="Search companies..." aria-label="Search companies" autoComplete="off"
// // //                     />
// // //                     <button type="submit" className="hx-go" aria-label="Search companies"><Icon name="arrow" className="hx-go-ic" /></button>
// // //                   </div>
// // //                 </form>
// // //                 <p className="hx-sub">Hiring made simple:</p>
// // //                 <div className="hx-chips">
// // //                   <Link to={hireLink} className="hx-chip">Post a Job</Link>
// // //                   <Link to="/employer/pricing" className="hx-chip">View hiring plans</Link>
// // //                   <Link to="/#employers" className="hx-chip">How hiring works</Link>
// // //                 </div>
// // //               </>
// // //             )}

// // //             {tab === 'resources' && (
// // //               <>
// // //                 <p className="hx-sub hx-sub-top">Free tools and guides:</p>
// // //                 <div className="hx-chips">
// // //                   {RESOURCES.map((r) => (
// // //                     <Link key={r.label} to={r.to} className="hx-chip">{r.label}</Link>
// // //                   ))}
// // //                 </div>
// // //               </>
// // //             )}

// // //             {/* existing PlanB Assistant entry points (unchanged behaviour) */}
// // //             <div className="hx-assist">
// // //               <p className="hx-assist-title">
// // //                 <span className="hx-live" aria-hidden="true" /> Ask the PlanB Assistant
// // //               </p>
// // //               <div className="hx-assist-actions">
// // //                 {ASSISTANT_ACTIONS.map((a) => (
// // //                   <button key={a} type="button" className="hx-mini" onClick={() => openAssistant(a)}>{a}</button>
// // //                 ))}
// // //               </div>
// // //               <form className="hx-ask" onSubmit={sendAsk}>
// // //                 <Icon name="chat" className="hx-ask-ic" />
// // //                 <input value={ask} onChange={(e) => setAsk(e.target.value)} placeholder="Ask something..." aria-label="Ask the PlanB Assistant" />
// // //                 <button type="submit" aria-label="Send"><Icon name="send" className="hx-ask-send" /></button>
// // //               </form>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         {/* ------------------------------ stats ------------------------------ */}
// // //         <div className="hx-stats hx-up" style={{ animationDelay: '.55s' }}>
// // //           {statList.map((s) => (
// // //             <div className="hx-stat" key={s.key || s.label}>
// // //               <span className={`hx-stat-ic hx-ic-${s.icon}`}><Icon name={s.icon} className="hx-stat-svg" fill={s.icon === 'star' || s.icon === 'bolt' ? 'currentColor' : 'none'} strokeWidth={s.icon === 'star' || s.icon === 'bolt' ? 1.5 : 2} /></span>
// // //               <div>
// // //                 <p className="hx-stat-n"><CountUp end={s.end} decimals={s.decimals || 0} suffix={s.suffix || ''} /></p>
// // //                 <p className="hx-stat-l">{s.label}</p>
// // //               </div>
// // //             </div>
// // //           ))}
// // //           <div className="hx-stat hx-trust">
// // //             <div className="hx-avatars" aria-hidden="true">
// // //               {['#743BFF', '#E83FAF', '#5B8CFF', '#F59E0B', '#10B981'].map((c, i) => (
// // //                 <span key={c} style={{ background: c, zIndex: 5 - i }}><Icon name="person" className="hx-av-ic" /></span>
// // //               ))}
// // //             </div>
// // //             <p className="hx-trust-t">{TRUSTED_LABEL[0]}<br /><strong>{TRUSTED_LABEL[1]}</strong></p>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // }

// // // /* --------------------------------- styles --------------------------------- */
// // // const css = `
// // // .hx{--p:#743BFF;--k:#E83FAF;--ink:#101536;--lav:#F6F0FF;--pink:#FFF0F8;--bd:#EAE2FA;
// // //   position:relative;overflow:hidden;background:linear-gradient(180deg,#fff 0%,#F9F5FF 55%,#fff 100%);
// // //   color:var(--ink);padding:44px 0 84px;font-family:inherit}
// // // .hx *{box-sizing:border-box}
// // // .hx-blob{position:absolute;border-radius:50%;pointer-events:none}
// // // .hx-blob-a{right:-160px;top:-140px;width:560px;height:560px;background:radial-gradient(circle,#FFDDF0 0%,rgba(255,221,240,0) 68%)}
// // // .hx-blob-b{left:-180px;bottom:-200px;width:600px;height:600px;background:radial-gradient(circle,#E9DCFF 0%,rgba(233,220,255,0) 68%)}
// // // .hx-dots{position:absolute;left:14px;top:20px;width:90px;height:90px;opacity:.55;
// // //   background-image:radial-gradient(#C9B8F5 1.5px,transparent 1.6px);background-size:16px 16px;pointer-events:none}
// // // .hx-wrap{position:relative;max-width:1280px;margin:0 auto;padding:0 24px}
// // // .hx-grid{display:grid;grid-template-columns:minmax(0,1.5fr) minmax(0,.72fr) minmax(0,1.25fr);gap:0 8px;align-items:center}

// // // /* copy */
// // // .hx-copy{position:relative;z-index:2;padding-top:20px}
// // // .hx-badge{display:inline-flex;align-items:center;gap:8px;background:#F1E9FF;color:#5B2FD6;font-size:13px;font-weight:600;
// // //   padding:8px 16px;border-radius:999px;margin-bottom:22px}
// // // .hx-badge-ic{width:16px;height:16px;color:var(--k)}
// // // .hx-h1{position:relative;font-weight:800;letter-spacing:-.02em;line-height:1.06;margin:0 0 22px;
// // //   font-size:clamp(2.2rem,3.9vw,3.7rem);color:var(--ink)}
// // // .hx-grad{background:linear-gradient(90deg,#743BFF 0%,#E83FAF 100%);-webkit-background-clip:text;background-clip:text;
// // //   -webkit-text-fill-color:transparent;color:transparent}
// // // .hx-swoosh{position:absolute;left:46%;bottom:-14px;width:min(46%,230px);height:auto}
// // // .hx-p{max-width:520px;font-size:clamp(1rem,1.25vw,1.15rem);line-height:1.65;color:#4B5072;margin:0 0 30px}
// // // .hx-cta{display:flex;flex-wrap:wrap;gap:14px}
// // // .hx-btn{display:inline-flex;align-items:center;justify-content:center;gap:10px;height:56px;padding:0 32px;border-radius:999px;
// // //   font-size:1.05rem;font-weight:700;text-decoration:none;transition:transform .25s cubic-bezier(.2,.8,.2,1),box-shadow .25s,background-position .5s,background-color .2s}
// // // .hx-btn-ic{width:20px;height:20px}
// // // .hx-btn-primary{color:#fff;background-image:linear-gradient(90deg,#743BFF,#E83FAF,#743BFF);background-size:200% 100%;
// // //   box-shadow:0 14px 30px -12px rgba(116,59,255,.65)}
// // // .hx-btn-primary:hover{background-position:100% 0;transform:translateY(-2px);box-shadow:0 18px 34px -12px rgba(232,63,175,.6)}
// // // .hx-btn-ghost{color:var(--ink);background:#fff;border:2px solid #B79CFF}
// // // .hx-btn-ghost:hover{transform:translateY(-2px);background:var(--lav);border-color:var(--p)}
// // // .hx-btn-ghost .hx-btn-ic{color:#4B2BC8}
// // // .hx-btn:focus-visible,.hx-chip:focus-visible,.hx-tab:focus-visible,.hx-go:focus-visible,.hx-mini:focus-visible{outline:3px solid rgba(116,59,255,.45);outline-offset:3px}

// // // /* robot */
// // // .hx-robot-col{position:relative;z-index:3;padding-top:100px;margin:0 -26px 0 -10px}
// // // .hx-robot{width:100%;max-width:310px;margin:0 auto;animation:hxPop .9s cubic-bezier(.2,.9,.25,1.2) .25s both}
// // // .hx-robot-svg{display:block;width:100%;height:auto;overflow:visible}
// // // .hx-float{animation:hxFloat 4s ease-in-out infinite}
// // // .hx-shadow{transform-box:fill-box;transform-origin:center;animation:hxShadow 4s ease-in-out infinite}
// // // .hx-wave{transform-origin:90px 214px;animation:hxWave 2.4s ease-in-out infinite}
// // // .hx-spark{animation:hxSpark 2.4s ease-in-out infinite}
// // // .hx-head{transform-origin:150px 176px;animation:hxTilt 5s ease-in-out infinite}
// // // .hx-eyes{transform-box:fill-box;transform-origin:center;animation:hxBlink 5s infinite}
// // // .hx-antenna{animation:hxGlow 2s ease-in-out infinite}
// // // .hx-bubble{position:absolute;top:0;left:-6%;width:min(78%,230px);background:#fff;border:2px solid #DCCFFB;border-radius:22px;
// // //   padding:14px 18px;display:flex;flex-direction:column;gap:3px;font-size:.95rem;line-height:1.3;color:var(--ink);
// // //   box-shadow:0 16px 34px -18px rgba(116,59,255,.5);transform:rotate(-4deg);animation:hxBubble .7s cubic-bezier(.2,.9,.25,1.3) .9s both}
// // // .hx-bubble strong{font-size:1.2rem;font-weight:800}
// // // .hx-bubble-tail{position:absolute;left:52%;bottom:-10px;width:18px;height:18px;background:#fff;border-right:2px solid #DCCFFB;
// // //   border-bottom:2px solid #DCCFFB;transform:rotate(45deg)}
// // // .hx-bubble-spark{position:absolute;right:-26px;top:-16px;width:40px;height:30px}

// // // /* card */
// // // .hx-card{position:relative;z-index:2;background:rgba(255,255,255,.94);border:1px solid var(--bd);border-radius:30px;padding:26px 26px 22px;
// // //   box-shadow:0 40px 70px -36px rgba(116,59,255,.5),0 2px 0 rgba(255,255,255,.8) inset;animation:hxSlide .8s cubic-bezier(.2,.8,.2,1) .3s both}
// // // .hx-tabs{display:flex;gap:10px;flex-wrap:wrap;margin-bottom:22px}
// // // .hx-tab{display:inline-flex;align-items:center;gap:8px;height:46px;padding:0 20px;border-radius:999px;border:0;cursor:pointer;
// // //   font:inherit;font-size:.95rem;font-weight:700;color:#4B5072;background:#F3EEFB;transition:all .25s}
// // // .hx-tab:hover{background:#EBE0FF;color:var(--p)}
// // // .hx-tab.is-on{color:#fff;background:linear-gradient(90deg,#743BFF,#8B4DFF);box-shadow:0 12px 24px -10px rgba(116,59,255,.7)}
// // // .hx-tab-ic{width:18px;height:18px}
// // // .hx-q{font-size:1.3rem;font-weight:800;margin:0 0 14px;color:var(--ink)}
// // // .hx-search{display:flex;align-items:center;gap:10px;height:60px;padding:0 8px 0 18px;background:#fff;border:1.5px solid var(--bd);
// // //   border-radius:999px;transition:border-color .2s,box-shadow .2s}
// // // .hx-search:focus-within{border-color:var(--p);box-shadow:0 0 0 4px rgba(116,59,255,.12)}
// // // .hx-search-ic{width:22px;height:22px;color:var(--p);flex:none}
// // // .hx-search input{flex:1;min-width:0;border:0;outline:0;background:transparent;font:inherit;font-size:1.02rem;color:var(--ink)}
// // // .hx-search input::placeholder{color:#8C90A8}
// // // .hx-go{flex:none;width:48px;height:48px;border-radius:50%;border:0;cursor:pointer;color:#fff;display:flex;align-items:center;justify-content:center;
// // //   background:linear-gradient(135deg,#743BFF,#8B4DFF);box-shadow:0 10px 20px -8px rgba(116,59,255,.7);transition:transform .25s}
// // // .hx-go:hover{transform:scale(1.08) translateX(2px)}
// // // .hx-go-ic{width:22px;height:22px}
// // // .hx-more{margin:10px 0 0 6px;padding:0;border:0;background:none;cursor:pointer;font:inherit;font-size:.82rem;font-weight:700;color:var(--p)}
// // // .hx-more:hover{text-decoration:underline}
// // // .hx-filters{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:10px}
// // // .hx-filters input,.hx-filters select{height:44px;border:1.5px solid var(--bd);border-radius:999px;padding:0 16px;font:inherit;font-size:.9rem;
// // //   background:#fff;color:var(--ink);outline:0}
// // // .hx-filters input:focus,.hx-filters select:focus{border-color:var(--p)}
// // // .hx-sub{font-weight:800;font-size:.98rem;margin:20px 0 10px}
// // // .hx-sub-top{margin-top:4px}
// // // .hx-chips{display:flex;flex-wrap:wrap;gap:10px}
// // // .hx-chip{display:inline-flex;align-items:center;height:38px;padding:0 16px;border-radius:999px;border:1.5px solid #DCCFFB;background:#fff;
// // //   font:inherit;font-size:.86rem;font-weight:600;color:#2A2F5C;text-decoration:none;cursor:pointer;transition:all .22s}
// // // .hx-chip:hover{transform:translateY(-2px);border-color:var(--p);color:var(--p);background:var(--lav);box-shadow:0 10px 18px -12px rgba(116,59,255,.7)}
// // // .hx-assist{margin-top:20px;padding-top:16px;border-top:1px dashed var(--bd)}
// // // .hx-assist-title{display:flex;align-items:center;gap:8px;font-size:.85rem;font-weight:800;margin:0 0 10px;color:var(--ink)}
// // // .hx-live{width:8px;height:8px;border-radius:50%;background:#22C55E;box-shadow:0 0 0 0 rgba(34,197,94,.5);animation:hxLive 2s infinite}
// // // .hx-assist-actions{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:10px}
// // // .hx-mini{height:30px;padding:0 12px;border-radius:999px;border:0;background:var(--lav);color:#5B2FD6;font:inherit;font-size:.76rem;font-weight:700;cursor:pointer;transition:all .2s}
// // // .hx-mini:hover{background:linear-gradient(90deg,#743BFF,#E83FAF);color:#fff}
// // // .hx-ask{display:flex;align-items:center;gap:8px;height:44px;padding:0 6px 0 14px;border:1.5px solid var(--bd);border-radius:999px;background:#fff}
// // // .hx-ask:focus-within{border-color:var(--p)}
// // // .hx-ask-ic{width:18px;height:18px;color:var(--p);flex:none}
// // // .hx-ask input{flex:1;min-width:0;border:0;outline:0;background:transparent;font:inherit;font-size:.9rem;color:var(--ink)}
// // // .hx-ask button{width:34px;height:34px;border-radius:50%;border:0;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#fff;
// // //   background:linear-gradient(135deg,#743BFF,#E83FAF)}
// // // .hx-ask-send{width:16px;height:16px}

// // // /* stats */
// // // .hx-stats{display:grid;grid-template-columns:repeat(4,1fr) 1.15fr;margin-top:44px;background:rgba(255,255,255,.92);border:1px solid var(--bd);
// // //   border-radius:28px;padding:22px 12px;box-shadow:0 30px 60px -38px rgba(116,59,255,.45)}
// // // .hx-stat{display:flex;align-items:center;gap:14px;padding:4px 22px;border-left:1px solid #E6DBFA}
// // // .hx-stat:first-child{border-left:0}
// // // .hx-stat-ic{flex:none;width:48px;height:48px;display:flex;align-items:center;justify-content:center;border-radius:14px;color:var(--p);background:var(--lav)}
// // // .hx-stat-ic.hx-ic-star{color:#F5A524;background:#FFF6E3}
// // // .hx-stat-ic.hx-ic-bolt{color:#4B6BFF;background:#EEF1FF}
// // // .hx-stat-svg{width:26px;height:26px}
// // // .hx-stat-n{margin:0;font-size:1.55rem;font-weight:800;line-height:1.1;color:var(--ink);font-variant-numeric:tabular-nums}
// // // .hx-stat-l{margin:2px 0 0;font-size:.9rem;color:#5E6385}
// // // .hx-trust{gap:12px}
// // // .hx-avatars{display:flex}
// // // .hx-avatars span{width:38px;height:38px;border-radius:50%;border:2px solid #fff;margin-left:-10px;display:flex;align-items:center;justify-content:center;color:#fff}
// // // .hx-avatars span:first-child{margin-left:0}
// // // .hx-av-ic{width:20px;height:20px}
// // // .hx-trust-t{margin:0;font-size:.82rem;line-height:1.3;color:#5E6385}
// // // .hx-trust-t strong{color:var(--p);font-size:.95rem}

// // // /* entrance */
// // // .hx-up{animation:hxUp .8s cubic-bezier(.2,.8,.2,1) both}
// // // @keyframes hxUp{from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:none}}
// // // @keyframes hxSlide{from{opacity:0;transform:translateX(40px)}to{opacity:1;transform:none}}
// // // @keyframes hxPop{from{opacity:0;transform:scale(.8) translateY(20px)}to{opacity:1;transform:none}}
// // // @keyframes hxBubble{from{opacity:0;transform:rotate(-4deg) scale(.6)}to{opacity:1;transform:rotate(-4deg) scale(1)}}
// // // @keyframes hxFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-9px)}}
// // // @keyframes hxShadow{0%,100%{transform:scaleX(1);opacity:.18}50%{transform:scaleX(.88);opacity:.12}}
// // // @keyframes hxWave{0%,100%{transform:rotate(-10deg)}25%{transform:rotate(16deg)}50%{transform:rotate(-6deg)}75%{transform:rotate(14deg)}}
// // // @keyframes hxSpark{0%,100%{opacity:.25}50%{opacity:1}}
// // // @keyframes hxTilt{0%,100%{transform:rotate(-3deg)}50%{transform:rotate(3deg)}}
// // // @keyframes hxBlink{0%,92%,100%{transform:scaleY(1)}95%{transform:scaleY(.1)}}
// // // @keyframes hxGlow{0%,100%{opacity:1}50%{opacity:.45}}
// // // @keyframes hxLive{0%{box-shadow:0 0 0 0 rgba(34,197,94,.5)}100%{box-shadow:0 0 0 10px rgba(34,197,94,0)}}

// // // /* tablet */
// // // @media (max-width:1180px){
// // //   .hx-grid{grid-template-columns:minmax(0,1.4fr) minmax(0,.7fr) minmax(0,1.3fr)}
// // //   .hx-card{padding:22px 18px 18px}
// // //   .hx-tab{padding:0 14px;height:42px;font-size:.88rem}
// // //   .hx-stat{padding:4px 12px;gap:10px}
// // //   .hx-stat-ic{width:42px;height:42px}
// // // }
// // // /* stacked: tablet portrait and mobile */
// // // @media (max-width:1023px){
// // //   .hx{padding:28px 0 76px}
// // //   .hx-grid{grid-template-columns:1fr;gap:12px}
// // //   .hx-copy{order:1;padding-top:0}
// // //   .hx-robot-col{order:2;margin:0 auto;padding-top:96px;width:min(300px,78%)}
// // //   .hx-card{order:3;max-width:640px;width:100%;margin:0 auto}
// // //   .hx-bubble{left:-12%;width:min(86%,230px)}
// // //   .hx-stats{grid-template-columns:repeat(2,1fr);gap:18px 0;padding:20px 12px}
// // //   .hx-stat:nth-child(odd){border-left:0}
// // //   .hx-trust{grid-column:1 / -1;border-left:0;justify-content:center;padding-top:14px;border-top:1px solid #E6DBFA}
// // // }
// // // @media (max-width:560px){
// // //   .hx-wrap{padding:0 16px}
// // //   .hx-btn{height:52px;padding:0 24px;flex:1 1 100%}
// // //   .hx-tab{flex:1 1 auto;justify-content:center}
// // //   .hx-filters{grid-template-columns:1fr}
// // //   .hx-stat-n{font-size:1.3rem}
// // //   .hx-stat-l{font-size:.8rem}
// // // }
// // // @media (prefers-reduced-motion:reduce){
// // //   .hx *,.hx *::before,.hx *::after{animation:none!important;transition:none!important}
// // // }
// // // `;




// import { useEffect, useRef, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';

// /*
//   IMAGES (put in /public):
//     /hero-bg.jpg     (or .jpeg/.png/.webp/.svg) full background illustration: sky + city + the group of
//                      professionals, WITHOUT any text / buttons / UI on it.
//                      Best size 1672 x 941 (or same ratio).
//     /hero-robot.svg  robot mascot, transparent PNG (optional)

//   Optional props from Home.jsx for the Industry dropdown:
//     industry, setIndustry, departments   (departments = [{slug, name}])

//   Desktop (>=1024px): everything is placed in a 1672px design canvas and
//   scales with the screen width. Below 1024px it stacks.
// */

// const DESIGN_W = 1672;
// const u = (n) => `calc(100vw / ${DESIGN_W} * ${n})`;

// const CHECKS = ['For Everyone', '100% Free', 'Trusted by Millions'];

// const CHAT_OPTIONS = [
//   { label: 'A better job', emoji: '💼', to: '/jobs' },
//   { label: 'A higher-paying job', emoji: '💰', to: '/jobs' },
//   { label: "I'm changing careers", emoji: '🔄', to: '/jobs' },
//   { label: 'A job near me', emoji: '📍', to: '/#jobs' },
//   { label: "I'm open to opportunities", emoji: '✨', to: '/register' },
// ];

// const POPULAR_JOBS = [
//   { label: 'Delivery Partner', emoji: '🛵', to: '/jobs?keyword=delivery' },
//   { label: 'Construction Worker', emoji: '👷', to: '/jobs?keyword=construction' },
//   { label: 'Doctor', emoji: '🩺', to: '/jobs/healthcare' },
//   { label: 'Electrician', emoji: '💡', to: '/jobs?keyword=electrician' },
//   { label: 'Plumber', emoji: '🔧', to: '/jobs?keyword=plumber' },
//   { label: 'Driver', emoji: '🚗', to: '/jobs?keyword=driver' },
//   { label: 'Chef', emoji: '👨‍🍳', to: '/jobs?keyword=chef' },
//   { label: 'Healthcare Staff', emoji: '🧰', to: '/jobs/healthcare' },
//   { label: 'Sales Executive', emoji: '📊', to: '/jobs/sales' },
//   { label: 'Marketing Specialist', emoji: '📣', to: '/jobs/digital-marketing' },
// ];

// const STATS = [
//   { icon: 'users', big: '10M+', small: 'Job Seekers', x: 165 },
//   { icon: 'building', big: '50K+', small: 'Hiring Companies', x: 490 },
//   { icon: 'star', big: '4.8/5', small: 'User Rating', x: 802 },
//   { icon: 'bolt', big: 'Free for Job Seekers', small: 'No Hidden Charges', x: 1070 },
// ];

// function useDesktop() {
//   const [d, setD] = useState(() => typeof window !== 'undefined' && window.innerWidth >= 1024);
//   useEffect(() => {
//     const on = () => setD(window.innerWidth >= 1024);
//     window.addEventListener('resize', on);
//     return () => window.removeEventListener('resize', on);
//   }, []);
//   return d;
// }

// function StatIcon({ name, size }) {
//   const st = { width: size, height: size };
//   const cls = 'shrink-0';
//   if (name === 'users')
//     return (
//       <svg viewBox="0 0 24 24" style={st} className={`${cls} text-[#C4B5FD]`} fill="currentColor" aria-hidden="true">
//         <circle cx="12" cy="7" r="3.2" /><circle cx="5" cy="9" r="2.4" opacity=".7" /><circle cx="19" cy="9" r="2.4" opacity=".7" />
//         <path d="M6.5 20v-2.5A4.5 4.5 0 0111 13h2a4.5 4.5 0 014.5 4.5V20z" />
//       </svg>
//     );
//   if (name === 'building')
//     return (
//       <svg viewBox="0 0 24 24" style={st} className={`${cls} text-[#C4B5FD]`} fill="currentColor" aria-hidden="true">
//         <path d="M4 3h10v18H4z" /><path opacity=".75" d="M15 9h5v12h-5z" />
//         <path fill="#5B21B6" d="M6.5 6h2v2h-2zM10 6h2v2h-2zM6.5 10h2v2h-2zM10 10h2v2h-2zM6.5 14h2v2h-2zM10 14h2v2h-2z" />
//       </svg>
//     );
//   if (name === 'star')
//     return (
//       <svg viewBox="0 0 24 24" style={st} className={`${cls} text-[#FBBF24]`} fill="currentColor" aria-hidden="true">
//         <path d="M12 2l3 6.6 7 .8-5.2 4.8 1.5 7L12 17.7 5.7 21.2l1.5-7L2 9.4l7-.8z" />
//       </svg>
//     );
//   return (
//     <svg viewBox="0 0 24 24" style={st} className={`${cls} text-[#FBBF24]`} fill="currentColor" aria-hidden="true">
//       <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" />
//     </svg>
//   );
// }

// function Chev({ size = 14, color = 'currentColor' }) {
//   return (
//     <svg viewBox="0 0 24 24" style={{ width: size, height: size }} fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
//   );
// }

// export default function HeroSection({
//   keyword = '',
//   setKeyword = () => {},
//   location = '',
//   setLocation = () => {},
//   industry = '',
//   setIndustry = () => {},
//   departments = [],
//   onSearch,
// }) {
//   const navigate = useNavigate();
//   const d = useDesktop();
//   const [chatOpen, setChatOpen] = useState(true);
//   const [chatMin, setChatMin] = useState(false);
//   const [msg, setMsg] = useState('');
//   const railRef = useRef(null);

//   const box = (x, y, w, h) =>
//     d ? { position: 'absolute', left: u(x), top: u(y), width: w != null ? u(w) : undefined, height: h != null ? u(h) : undefined } : {};
//   const fs = (n, lh) => (d ? { fontSize: u(n), lineHeight: lh ? u(lh) : undefined } : {});

//   const sendMsg = (e) => {
//     e.preventDefault();
//     const q = msg.trim();
//     navigate(q ? `/jobs?keyword=${encodeURIComponent(q)}` : '/jobs');
//   };

//   const scrollRail = (dir) => railRef.current?.scrollBy({ left: dir * 320, behavior: 'smooth' });

//   return (
//     <section
//       className="hero-sec relative overflow-hidden"
//       style={d ? { height: u(849), marginBottom: '2.5rem' } : { paddingBottom: '1rem' }}
//     >
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Caveat:wght@600;700&display=swap');
//         .hero-sec { font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
//           background: linear-gradient(180deg,#BFD6F6 0%,#D9D2F7 45%,#F1E4F8 100%); }

// .hero-sec .hero-bg {
//   position: absolute;
//   inset: 0;
//   background: none;
//   pointer-events: none;
//   z-index: 1;
// }


// .hero-sec .hero-people {
//   position: absolute;
//   right: 10%;
//   bottom: -2%;
//   width: 65%;
//   height: 115%;
//   object-fit: contain;
//   object-position: center bottom;
//   transform: translateY(-110px);
//   transform-origin: center bottom;
//   z-index: 2;
//   pointer-events: none;
// }


//           -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 var(--hero-bg-fade, 8%), #000 calc(100% - var(--hero-bg-fade, 8%)), transparent 100%), linear-gradient(180deg, transparent 0, #000 12%);
//           -webkit-mask-composite: source-in; mask-composite: intersect;
//           mask-image: linear-gradient(90deg, transparent 0, #000 var(--hero-bg-fade, 8%), #000 calc(100% - var(--hero-bg-fade, 8%)), transparent 100%), linear-gradient(180deg, transparent 0, #000 12%); }
//         .hero-sec .grad { background-image: linear-gradient(90deg,#5B21B6 0%,#7C3AED 35%,#C026D3 70%,#EC4899 100%);
//           -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; color:transparent; }
//         .hero-sec .script { font-family:'Caveat', cursive; }
//         .hero-sec .btn-find { background-image:linear-gradient(90deg,#5B21B6,#7C3AED 55%,#DB2777); box-shadow:0 14px 30px -10px rgba(124,58,237,.7); transition:transform .25s ease; }
//         .hero-sec .btn-find:hover { transform:translateY(-2px); }
//         .hero-sec .glass { background:rgba(255,255,255,.82); backdrop-filter:blur(10px); -webkit-backdrop-filter:blur(10px); }
//         .hero-sec .rail::-webkit-scrollbar { display:none; } .hero-sec .rail { scrollbar-width:none; }
//         @keyframes hero-float { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-8px); } }
//         .hero-sec .float-a { animation:hero-float 5s ease-in-out infinite; }
//         @media (prefers-reduced-motion: reduce) { .hero-sec .float-a { animation:none; } }
//       `}</style>

//       {d && (
//   <>
//     <div className="hero-bg" aria-hidden="true" />
//     <img
//       src="/hero-people.png"
//       alt="Professionals from different careers"
//       className="hero-people"
//     />
//   </>
// )}
//       {/* soft readability wash behind the left text (very light) */}
//       {d && <div className="absolute inset-0 pointer-events-none" style={{ background: 'linear-gradient(90deg, rgba(255,255,255,.55) 0%, rgba(255,255,255,.25) 32%, transparent 48%)' }} aria-hidden="true" />}

//       {/* purple wave + stats */}
//       {d && (
//         <svg style={{ position: 'absolute', left: 0, bottom: 0, width: '100%', height: u(170) }} viewBox="0 0 1440 170" preserveAspectRatio="none" aria-hidden="true">
//           <defs>
//             <linearGradient id="waveA" x1="0" x2="1"><stop offset="0" stopColor="#6D28D9" /><stop offset=".55" stopColor="#7C3AED" /><stop offset="1" stopColor="#9333EA" /></linearGradient>
//             <linearGradient id="waveB" x1="0" x2="1"><stop offset="0" stopColor="#A78BFA" stopOpacity=".7" /><stop offset="1" stopColor="#F472B6" stopOpacity=".6" /></linearGradient>
//           </defs>
//           <path d="M0 60 C 220 0, 470 10, 740 50 S 1220 110, 1440 30 L1440 170 L0 170 Z" fill="url(#waveB)" />
//           <path d="M0 85 C 240 30, 480 40, 760 78 S 1220 128, 1440 62 L1440 170 L0 170 Z" fill="url(#waveA)" />
//         </svg>
//       )}

//       <div className={d ? '' : 'relative px-5 pt-6 flex flex-col gap-5'}>

//         {/* badge */}
//         <div
//           style={{ ...box(58, 51, null, 44), ...(d ? { gap: u(10), paddingLeft: u(18), paddingRight: u(6), zIndex: 5 } : {}) }}
//           className="glass inline-flex w-fit items-center rounded-full shadow-[0_8px_24px_-10px_rgba(124,58,237,.35)] border border-white/70 px-3 py-1.5 gap-2"
//         >
//           <svg viewBox="0 0 24 24" style={d ? { width: u(24), height: u(24) } : { width: 16, height: 16 }} className="text-[#F59E0B]" fill="currentColor" aria-hidden="true"><path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" /></svg>
//           <span style={fs(18)} className="font-semibold text-[#1E0F3D] text-sm">India&rsquo;s Smarter Job Portal</span>
//           <span style={d ? { ...fs(16), padding: `${u(9)} ${u(14)}` } : {}} className="font-bold text-white bg-[#5B21B6] rounded-full px-3 py-1 text-xs whitespace-nowrap">🚀 100% Free</span>
//         </div>

//         {/* headline */}
//         <h1
//           style={{ ...box(57, 112, 760, null), ...fs(63, 66), letterSpacing: '-0.035em', whiteSpace: d ? 'nowrap' : 'normal', zIndex: 5 }}
//           className="font-extrabold text-[#0B0A1F] text-[2.5rem] sm:text-6xl leading-[1.05]"
//         >
//           Find Your Next Move.
//           <span className="grad block">Build Your Future.</span>
//         </h1>

//         {d && (
//           <svg viewBox="0 0 200 20" style={{ ...box(455, 250, 200, 20), zIndex: 5 }} fill="none" aria-hidden="true">
//             <path d="M4 14 C 50 4, 120 2, 196 8" stroke="#DB2777" strokeWidth="4" strokeLinecap="round" />
//           </svg>
//         )}

//         {/* paragraph */}
//         <p style={{ ...box(57, 283, 540, null), ...fs(18, 26), zIndex: 5 }} className="text-[#2B2547] text-base leading-relaxed max-w-[560px]">
//           Your next opportunity could be closer than you think. Explore thousands of career possibilities, discover jobs matching your skills and connect with employers.
//         </p>

//         {/* checks */}
//         <ul style={{ ...box(57, 384, 520, 28), ...(d ? { gap: u(26), zIndex: 5 } : {}) }} className="flex flex-wrap items-center gap-x-5 gap-y-2">
//           {CHECKS.map((c) => (
//             <li key={c} style={d ? { gap: u(8), ...fs(16) } : {}} className="inline-flex items-center gap-2 text-sm font-semibold text-[#1E0F3D]">
//               <span style={d ? { width: u(24), height: u(24) } : { width: 20, height: 20 }} className="rounded-full bg-gradient-to-br from-[#6D28D9] to-[#9333EA] text-white flex items-center justify-center shrink-0">
//                 <svg viewBox="0 0 24 24" style={{ width: '62%', height: '62%' }} fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
//               </span>
//               {c}
//             </li>
//           ))}
//         </ul>

//         {/* search bar */}
//         <form
//           onSubmit={onSearch}
//           style={{ ...box(60, 438, 1030, 80), ...(d ? { paddingLeft: u(30), paddingRight: u(10), zIndex: 6 } : {}) }}
//           className="glass flex flex-col lg:flex-row lg:items-center rounded-3xl lg:rounded-full shadow-[0_20px_50px_-20px_rgba(76,29,149,.5)] border border-white p-3 gap-2 lg:gap-0"
//         >
//           <label className="flex items-center" style={d ? { width: u(335), gap: u(14) } : { gap: 10 }}>
//             <svg viewBox="0 0 24 24" style={d ? { width: u(28), height: u(28) } : { width: 20, height: 20 }} className="text-[#1E0F3D] shrink-0" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
//             <input
//               type="text" value={keyword} onChange={(e) => setKeyword(e.target.value)}
//               placeholder="Job title, skills or keywords" aria-label="Job title, skills or keywords"
//               style={fs(18)} className="flex-1 min-w-0 bg-transparent text-[15px] text-[#1E0F3D] placeholder:text-[#4B4766] focus:outline-none"
//             />
//           </label>
//           {d && <span style={{ width: 1, height: u(44) }} className="bg-[#1E0F3D]/20 shrink-0" aria-hidden="true" />}
//           <label className="flex items-center" style={d ? { width: u(215), padding: `0 ${u(26)}`, gap: u(12) } : { gap: 10 }}>
//             <svg viewBox="0 0 24 24" style={d ? { width: u(28), height: u(28) } : { width: 20, height: 20 }} className="text-[#DB2777] shrink-0" fill="currentColor" aria-hidden="true"><path d="M12 2a7 7 0 00-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 00-7-7zm0 9.5A2.5 2.5 0 119.5 9 2.5 2.5 0 0112 11.5z" /></svg>
//             <input
//               type="text" value={location} onChange={(e) => setLocation(e.target.value)}
//               placeholder="Location" aria-label="Location"
//               style={fs(18)} className="flex-1 min-w-0 bg-transparent font-semibold text-[15px] text-[#1E0F3D] placeholder:text-[#1E0F3D] focus:outline-none"
//             />
//           </label>
//           {d && <span style={{ width: 1, height: u(44) }} className="bg-[#1E0F3D]/20 shrink-0" aria-hidden="true" />}
//           <label className="flex items-center" style={d ? { width: u(205), padding: `0 ${u(26)}`, gap: u(12) } : { gap: 10 }}>
//             <svg viewBox="0 0 24 24" style={d ? { width: u(30), height: u(30) } : { width: 20, height: 20 }} className="text-[#1E0F3D] shrink-0" fill="currentColor" aria-hidden="true"><path d="M9 4h6a1 1 0 011 1v2h4a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V9a2 2 0 012-2h4V5a1 1 0 011-1zm1 3h4V6h-4zM2 13h20v-1H2z" /></svg>
//             <select
//               value={industry} onChange={(e) => setIndustry(e.target.value)} aria-label="Industry"
//               style={fs(18)} className="flex-1 min-w-0 bg-transparent font-semibold text-[15px] text-[#1E0F3D] focus:outline-none appearance-none cursor-pointer"
//             >
//               <option value="">Industry</option>
//               {departments.map((x) => <option key={x.slug} value={x.slug}>{x.name}</option>)}
//             </select>
//             <Chev size={d ? 14 : 12} />
//           </label>
//           {d && <span style={{ width: 1, height: u(44) }} className="bg-[#1E0F3D]/20 shrink-0" aria-hidden="true" />}
//           <button
//             type="submit"
//             style={d ? { ...fs(21), width: u(229), height: u(68), gap: u(12), marginLeft: 'auto' } : {}}
//             className="btn-find shrink-0 inline-flex items-center justify-center text-white font-bold text-base rounded-full px-6 py-3 gap-2"
//           >
//             Find Jobs
//             <svg viewBox="0 0 24 24" style={d ? { width: u(26), height: u(26) } : { width: 20, height: 20 }} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
//           </button>
//         </form>

//         {/* swoosh around the button */}
//         {d && (
//           <svg viewBox="0 0 220 140" style={{ ...box(930, 395, 220, 140), zIndex: 7 }} fill="none" aria-hidden="true" className="pointer-events-none">
//             <defs><linearGradient id="swoosh" x1="0" x2="1"><stop offset="0" stopColor="#E879F9" /><stop offset="1" stopColor="#F9A8D4" /></linearGradient></defs>
//             <path d="M20 70 C 80 20, 160 -10, 200 55 C 215 90, 170 118, 130 122" stroke="url(#swoosh)" strokeWidth="5" strokeLinecap="round" style={{ filter: 'drop-shadow(0 0 8px rgba(232,121,249,.8))' }} />
//           </svg>
//         )}

//         {/* script captions + bubble + planes */}
//         {/* {d && (
//           <>
//             <p className="script font-bold text-[#3B1D8A]" style={{ ...box(712, 14, 340, null), ...fs(34, 36), transform: 'rotate(-10deg)', zIndex: 8, whiteSpace: 'nowrap' }}>
//               From Students<br /><span style={{ marginLeft: u(6) }}>to Professionals...</span>
//             </p>
//             <div
//               className="glass"
//               style={{ ...box(1093, 13, 175, 98), zIndex: 8, borderRadius: `${u(26)} ${u(26)} ${u(26)} ${u(4)}`, transform: 'rotate(-3deg)', boxShadow: '0 12px 30px -12px rgba(124,58,237,.35)' }}
//               aria-hidden="true"
//             >
//               <p className="script font-bold text-[#3B1D8A] text-center" style={{ ...fs(28, 30), paddingTop: u(14) }}>
//                 Jobs for<br />Every Profession!
//               </p>
//               <svg viewBox="0 0 120 10" style={{ width: u(100), display: 'block', margin: '0 auto' }} fill="none"><path d="M3 6 C 40 1, 80 1, 117 5" stroke="#DB2777" strokeWidth="3" strokeLinecap="round" /></svg>
//             </div>
//             <svg viewBox="0 0 24 24" style={{ ...box(515, 26, 52, 52), zIndex: 8, transform: 'rotate(15deg)' }} fill="#EDE9FE" stroke="#A78BFA" strokeWidth="1" aria-hidden="true"><path d="M2 12L22 3l-6 18-4-7z" /></svg>
//             <svg viewBox="0 0 24 24" style={{ ...box(1252, 106, 38, 38), zIndex: 8, transform: 'rotate(-20deg)' }} fill="#FBCFE8" stroke="#F472B6" strokeWidth="1" aria-hidden="true"><path d="M2 12L22 3l-6 18-4-7z" /></svg>
//           </>
//         )} */}

//         {/* popular jobs panel */}
//         <div
//           className="glass rounded-[28px] border border-white/70 shadow-[0_20px_50px_-25px_rgba(76,29,149,.45)]"
//           style={{ ...box(60, 543, 1298, 156), zIndex: 6, ...(d ? { borderRadius: u(30) } : { padding: 16 }) }}
//         >
//           <div style={d ? { position: 'absolute', left: u(36), top: u(14), right: u(40), ...fs(21) } : {}} className="flex items-center justify-between mb-3">
//             <p className="font-extrabold text-[#1E0F3D] inline-flex items-center gap-2"><span aria-hidden="true">🔥</span> Popular Jobs:</p>
//             <Link to="/jobs" style={fs(16)} className="font-bold text-[#6D28D9] text-sm inline-flex items-center gap-1">View all <span aria-hidden="true">→</span></Link>
//           </div>
//           <div
//             ref={railRef}
//             style={d ? { position: 'absolute', left: u(46), top: u(37), width: u(1236), height: u(112), gap: u(14) } : {}}
//             className="rail flex overflow-x-auto gap-3"
//           >
//             {POPULAR_JOBS.map((j) => (
//               <Link
//                 key={j.label}
//                 to={j.to}
//                 style={d ? { width: u(112), minWidth: u(112), padding: `${u(8)} ${u(4)}`, borderRadius: u(18) } : { minWidth: 96 }}
//                 className="shrink-0 flex flex-col items-center justify-center text-center bg-white/80 border border-white shadow-[0_8px_20px_-12px_rgba(76,29,149,.4)] hover:-translate-y-1 transition p-2 rounded-2xl"
//               >
//                 <span style={d ? { fontSize: u(44), lineHeight: 1 } : { fontSize: 32 }} aria-hidden="true">{j.emoji}</span>
//                 <span style={{ ...fs(15, 17), marginTop: d ? u(6) : 4 }} className="font-bold text-[#1E0F3D] text-xs leading-tight">{j.label}</span>
//               </Link>
//             ))}
//           </div>
//         </div>
//         {d && (
//           <>
//             <button type="button" onClick={() => scrollRail(-1)} aria-label="Previous jobs" style={{ ...box(32, 600, 56, 56), zIndex: 7 }} className="glass rounded-full shadow-lg flex items-center justify-center text-[#6D28D9]">
//               <svg viewBox="0 0 24 24" style={{ width: u(26), height: u(26) }} fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>
//             </button>
//             <button type="button" onClick={() => scrollRail(1)} aria-label="Next jobs" style={{ ...box(1345, 600, 56, 56), zIndex: 7 }} className="glass rounded-full shadow-lg flex items-center justify-center text-[#6D28D9]">
//               <svg viewBox="0 0 24 24" style={{ width: u(26), height: u(26) }} fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
//             </button>
//           </>
//         )}

//         {/* assistant card */}
//         {chatOpen && (
//           <div
//             style={{ ...box(1335, 60, 315, chatMin ? 72 : 516), zIndex: 30 }}
//             className="glass rounded-[26px] border border-white/80 shadow-[0_40px_80px_-30px_rgba(76,29,149,.55)] w-full"
//           >
//             <div
//               style={{ height: d ? u(72) : 64, borderRadius: d ? `${u(26)} ${u(26)} 0 0` : '26px 26px 0 0', backgroundImage: 'linear-gradient(90deg,#5B21B6,#7C3AED 55%,#DB2777)', ...(d ? { gap: u(12), padding: `0 ${u(16)}` } : {}) }}
//               className="flex items-center text-white px-4 gap-3"
//             >
//               <span style={d ? { width: u(42), height: u(42), fontSize: u(21) } : {}} className="relative w-10 h-10 rounded-full bg-white text-[#E11D2E] flex items-center justify-center font-extrabold shrink-0">
//                 B<span className="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-[#4ADE80] border-2 border-white" />
//               </span>
//               <div className="flex-1 min-w-0">
//                 <p style={fs(16)} className="font-bold leading-tight text-[15px]">PlanB Assistant</p>
//                 <p style={fs(12)} className="text-xs text-white/85">Your AI Career Guide</p>
//               </div>
//               <button type="button" onClick={() => setChatMin((v) => !v)} aria-label={chatMin ? 'Expand assistant' : 'Minimise assistant'} style={fs(24)} className="w-7 h-7 flex items-center justify-center leading-none hover:bg-white/15 rounded-full">&minus;</button>
//               <button type="button" onClick={() => setChatOpen(false)} aria-label="Close assistant" style={fs(24)} className="w-7 h-7 flex items-center justify-center leading-none hover:bg-white/15 rounded-full">&times;</button>
//             </div>

//             {!chatMin && (
//               <div className={d ? '' : 'p-4'}>
//                 <div style={d ? { position: 'absolute', left: u(16), top: u(114), width: u(150), padding: `${u(11)} ${u(12)}`, ...fs(14, 19) } : {}} className="bg-white rounded-2xl rounded-tl-sm shadow-[0_8px_24px_-12px_rgba(124,58,237,.4)] px-4 py-3 text-[14px] text-[#1E0F3D] max-w-[62%] mb-3">
//                   <p className="font-semibold">Hi! <span aria-hidden="true">👋</span></p>
//                   <p className="font-semibold">What are you</p>
//                   <p className="font-semibold text-[#6D28D9]">looking for today?</p>
//                 </div>
//                 <img
//                   src="/hero-robot.png" alt=""
//                   onError={(e) => { const el = e.currentTarget; const list = ['/hero-robot.webp', '/hero-robot.jpg', '/hero-robot.svg']; const n = Number(el.dataset.fb || 0); if (n < list.length) { el.dataset.fb = String(n + 1); el.src = list[n]; } else { el.style.display = 'none'; } }}
//                   className="float-a h-auto"
//                   style={d ? { position: 'absolute', left: u(165), top: u(66), width: u(150) } : { display: 'none' }}
//                 />

//                 <ul style={d ? { position: 'absolute', left: u(17), top: u(240), width: u(283), display: 'flex', flexDirection: 'column', gap: u(6) } : {}} className={d ? '' : 'space-y-2'}>
//                   {CHAT_OPTIONS.map((o) => (
//                     <li key={o.label}>
//                       <Link
//                         to={o.to}
//                         style={d ? { height: u(36), padding: `0 ${u(12)}`, gap: u(10), ...fs(14), whiteSpace: 'nowrap' } : {}}
//                         className="flex items-center gap-3 bg-white/90 rounded-xl border border-purple-100 px-3.5 py-2.5 text-[14px] font-semibold text-[#1E0F3D] hover:border-[#7C3AED]/50 transition"
//                       >
//                         <span style={d ? { width: u(26), fontSize: u(19) } : {}} className="w-6 text-center text-lg" aria-hidden="true">{o.emoji}</span>
//                         <span className="flex-1">{o.label}</span>
//                         <svg viewBox="0 0 24 24" style={d ? { width: u(15), height: u(15) } : { width: 15, height: 15 }} className="text-[#6D28D9]" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
//                       </Link>
//                     </li>
//                   ))}
//                 </ul>

//                 <form
//                   onSubmit={sendMsg}
//                   style={d ? { position: 'absolute', left: u(17), top: u(455), width: u(283), height: u(44), paddingLeft: u(16), paddingRight: u(4) } : {}}
//                   className="mt-3 flex items-center bg-white rounded-full border border-purple-100 pl-4 pr-1.5 py-1.5"
//                 >
//                   <input
//                     type="text" value={msg} onChange={(e) => setMsg(e.target.value)}
//                     placeholder="Type your message..." aria-label="Type your message"
//                     style={fs(14)} className="flex-1 min-w-0 bg-transparent text-sm text-[#1E0F3D] placeholder:text-[#4B4766] focus:outline-none"
//                   />
//                   <button type="submit" aria-label="Send" style={{ ...(d ? { width: u(38), height: u(38) } : {}), backgroundImage: 'linear-gradient(135deg,#5B21B6,#7C3AED)' }} className="w-9 h-9 rounded-full flex items-center justify-center text-white shrink-0">
//                     <svg viewBox="0 0 24 24" style={d ? { width: u(19), height: u(19) } : { width: 18, height: 18 }} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
//                   </button>
//                 </form>
//               </div>
//             )}
//           </div>
//         )}

//         {/* stats on the wave (desktop) / grid (mobile) */}
//         {d ? (
//           <>
//             {STATS.map((s) => (
//               <div key={s.small} style={{ ...box(s.x, 752, 330, 70), gap: u(18), zIndex: 9 }} className="flex items-center text-white">
//                 <StatIcon name={s.icon} size={u(56)} />
//                 <div>
//                   <p style={fs(s.big.length > 8 ? 21 : 29, 32)} className="font-extrabold leading-tight">{s.big}</p>
//                   <p style={fs(17, 22)} className="text-white/85">{s.small}</p>
//                 </div>
//               </div>
//             ))}
//             {[435, 750, 1018].map((x) => (
//               <span key={x} style={{ ...box(x, 762, 1, 50), zIndex: 9 }} className="bg-white/30" aria-hidden="true" />
//             ))}
//             <p className="script font-bold text-white" style={{ ...box(1440, 690, 210, null), ...fs(40, 42), transform: 'rotate(-10deg)', zIndex: 9 }}>
//               Your Career,<br /><span style={{ marginLeft: u(28) }}>Our Mission</span>
//               <svg viewBox="0 0 160 12" style={{ width: u(160), marginLeft: u(30), display: 'block' }} fill="none" aria-hidden="true"><path d="M3 8 C 40 2, 100 2, 157 5" stroke="#F472B6" strokeWidth="3" strokeLinecap="round" /></svg>
//             </p>
//           </>
//         ) : (
//           <ul className="grid grid-cols-2 gap-4 rounded-3xl px-5 py-5 text-white" style={{ backgroundImage: 'linear-gradient(135deg,#5B21B6,#7C3AED)' }}>
//             {STATS.map((s) => (
//               <li key={s.small} className="flex items-center gap-3">
//                 <StatIcon name={s.icon} size={34} />
//                 <div>
//                   <p className="font-extrabold text-base leading-tight">{s.big}</p>
//                   <p className="text-xs text-white/85">{s.small}</p>
//                 </div>
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>
//     </section>
//   );
// }





import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import RegisterChat from './Register';
import landingData from '../seo/landingData';
/*
  FILES in /public:
    /hero-people.png   cut-out of the group of professionals (transparent background)
    /hero-robot.png    robot mascot, transparent (.webp / .svg also work)

  Props from Home.jsx (all optional):
    keyword, setKeyword, location, setLocation, industry, setIndustry, departments, onSearch

  Desktop (>=1024px): everything sits in a 1672px design canvas and scales with
  the screen width, so it matches the design at any desktop size.
  Below 1024px the layout stacks.

  TUNE THE PEOPLE IMAGE HERE (design pixels, canvas is 1672 x 849):
    x      = left edge of the image
    w      = width of the image
    bottom = y position of the bottom edge of the image
*/
const PEOPLE = { x: 344, w: 1137, bottom: 459 };

const DESIGN_W = 1672;
const u = (n) => `calc(100vw / ${DESIGN_W} * ${n})`;

const CHECKS = ['For Everyone', '100% Free', 'Trusted by Millions'];

const EXP = { role: 'job_seeker', experienceLevel: 'experienced' };

const CHAT_OPTIONS = [
  { label: 'A better job', emoji: '💼', to: '/jobs', preset: EXP },
  { label: 'A higher-paying job', emoji: '💰', to: '/jobs', preset: EXP },
  { label: "I'm changing careers", emoji: '🔄', to: '/jobs', preset: EXP },
  { label: 'A job near me', emoji: '📍', to: '/#jobs' },
  { label: "I'm open to opportunities", emoji: '✨', to: '/register', preset: { role: 'job_seeker' } },
];

const POPULAR_JOBS = [
  { label: 'Delivery Partner', emoji: '🛵', match: 'delivery', to: '/jobs?keyword=delivery' },
  { label: 'Construction Worker', emoji: '👷', match: 'construction', to: '/jobs?keyword=construction' },
  { label: 'Doctor', emoji: '🩺', match: 'doctor', to: '/jobs/healthcare' },
  { label: 'Electrician', emoji: '💡', match: 'electrician', to: '/jobs?keyword=electrician' },
  { label: 'Plumber', emoji: '🔧', match: 'plumber', to: '/jobs?keyword=plumber' },
  { label: 'Driver', emoji: '🚗', match: 'driver', to: '/jobs?keyword=driver' },
  { label: 'Chef', emoji: '👨‍🍳', match: 'chef', to: '/jobs?keyword=chef' },
  { label: 'Healthcare Staff', emoji: '🧰', match: 'healthcare', to: '/jobs/healthcare' },
  { label: 'Sales Executive', emoji: '📊', match: 'sales', to: '/jobs/sales' },
  { label: 'Marketing Specialist', emoji: '📣', match: 'marketing', to: '/jobs/digital-marketing' },
];

// EDIT ME: replace these with your real numbers
const HERO_STATS = [
  { emoji: '👥', big: '10M+', small: 'Job Seekers' },
  { emoji: '🏢', big: '50K+', small: 'Hiring Companies' },
  { emoji: '⭐', big: '4.8/5', small: 'User Rating' },
  { emoji: '🎁', big: '100% Free', small: 'For Job Seekers' },
];

const SEO_PAGES = [
  ...(landingData.TITLES || []),
  ...(landingData.INDUSTRIES || []),
];

const pageText = (p) =>
  `${p.slug || ''} ${p.name || ''} ${p.listing?.keyword || ''}`.toLowerCase();

// Finds the matching landing page, or falls back to the card's own link
const popularPath = (job) => {
  const label = job.label.toLowerCase();
  const word = job.match.toLowerCase();
  const hit =
    SEO_PAGES.find((p) => (p.name || '').toLowerCase() === label) ||
    SEO_PAGES.find((p) => (p.slug || '').toLowerCase() === word) ||
    SEO_PAGES.find((p) => pageText(p).includes(word));
  return hit ? hit.path : job.to;
};

function useDesktop() {
  const [d, setD] = useState(() => typeof window !== 'undefined' && window.innerWidth >= 1024);
  useEffect(() => {
    const on = () => setD(window.innerWidth >= 1024);
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  return d;
}

function Chev({ size = 14 }) {
  return (
    <svg viewBox="0 0 24 24" style={{ width: size, height: size }} fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
  );
}

function Robot() {
  return (
    <svg viewBox="0 0 120 130" style={{ width: '100%', height: 'auto', display: 'block', overflow: 'visible' }} role="img" aria-label="PlanB assistant robot">
      <defs>
        <linearGradient id="rbBody" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#FFFFFF" /><stop offset="1" stopColor="#E3E7FF" />
        </linearGradient>
        <linearGradient id="rbBlue" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#5B8CFF" /><stop offset="1" stopColor="#3B4FE0" />
        </linearGradient>
      </defs>
      {/* antennas */}
      <line x1="44" y1="26" x2="40" y2="14" stroke="#9AA3C7" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="39" cy="10" r="4.5" fill="url(#rbBlue)" />
      <line x1="76" y1="26" x2="80" y2="14" stroke="#9AA3C7" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="81" cy="10" r="4.5" fill="#7C3AED" />
      {/* ears */}
      <circle cx="22" cy="52" r="9" fill="url(#rbBlue)" />
      <circle cx="98" cy="52" r="9" fill="url(#rbBlue)" />
      {/* head */}
      <rect x="26" y="24" width="68" height="56" rx="26" fill="url(#rbBody)" stroke="#D5DAF5" strokeWidth="1.5" />
      <rect x="33" y="31" width="54" height="42" rx="19" fill="#0B1236" />
      <ellipse cx="49" cy="50" rx="4.5" ry="6" fill="#36E3FF" />
      <ellipse cx="71" cy="50" rx="4.5" ry="6" fill="#36E3FF" />
      <path d="M52 62 Q60 69 68 62" stroke="#36E3FF" strokeWidth="2.6" strokeLinecap="round" fill="none" />
      {/* right arm */}
      <rect x="84" y="90" width="12" height="28" rx="6" fill="url(#rbBody)" stroke="#D5DAF5" strokeWidth="1.5" transform="rotate(-12 90 92)" />
      {/* body */}
      <rect x="36" y="84" width="48" height="42" rx="20" fill="url(#rbBody)" stroke="#D5DAF5" strokeWidth="1.5" />
      <circle cx="60" cy="104" r="9" fill="url(#rbBlue)" />
      <text x="60" y="108" textAnchor="middle" fontSize="11" fontWeight="800" fill="#fff" fontFamily="system-ui, sans-serif">B</text>
      {/* waving arm */}
      <g transform="rotate(28 28 88)">
        <rect x="22" y="76" width="12" height="28" rx="6" fill="url(#rbBody)" stroke="#D5DAF5" strokeWidth="1.5" />
        <circle cx="28" cy="74" r="7" fill="#fff" stroke="#D5DAF5" strokeWidth="1.5" />
      </g>
    </svg>
  );
}

export default function HeroSection({
  keyword = '',
  setKeyword = () => {},
  location = '',
  setLocation = () => {},
  industry = '',
  setIndustry = () => {},
  departments = [],
  onSearch,
    onKeywordChange, keywordSuggestions = [], onKeywordPick = () => {}, onKeywordBlur = () => {},
  onLocationChange, locationSuggestions = [], onLocationPick = () => {}, onLocationBlur = () => {},
}) {
  const navigate = useNavigate();
  const d = useDesktop();
  const [chatOpen, setChatOpen] = useState(true);
  const [chatMin, setChatMin] = useState(false);
  const [msg, setMsg] = useState('');
  const railRef = useRef(null);

  const [registerPreset, setRegisterPreset] = useState(null);
  const [indOpen, setIndOpen] = useState(false);
  const indRef = useRef(null);

  useEffect(() => {
    const close = (e) => { if (indRef.current && !indRef.current.contains(e.target)) setIndOpen(false); };
    const esc = (e) => { if (e.key === 'Escape') setIndOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', esc); };
  }, []);
  const indLabel = departments.find((x) => x.slug === industry)?.name || 'Industry';
const isLoggedIn = !!localStorage.getItem('token');

  const box = (x, y, w, h) =>
    d ? { position: 'absolute', left: u(x), top: u(y), width: w != null ? u(w) : undefined, height: h != null ? u(h) : undefined } : {};
  const fs = (n, lh) => (d ? { fontSize: u(n), lineHeight: lh ? u(lh) : undefined } : {});

  const sugBox = { position: 'absolute', top: 'calc(100% + 16px)', left: 0, minWidth: '100%', width: 'max-content', maxWidth: 300, maxHeight: 240, overflowY: 'auto', background: '#fff', borderRadius: 14, boxShadow: '0 20px 40px -12px rgba(76,29,149,.35)', border: '1px solid #eee', zIndex: 50, textAlign: 'left', padding: '6px 0' };
const SugList = ({ items, onPick }) => (
  <ul style={sugBox}>
    {items.map((s, i) => (
      <li key={i} onMouseDown={() => onPick(s)} className="px-4 py-2 text-sm text-gray-700 hover:bg-[#F3F0FF] hover:text-[#4F23D8] cursor-pointer whitespace-nowrap">{s}</li>
    ))}
  </ul>
);

  const sendMsg = (e) => {
    e.preventDefault();
    const q = msg.trim();
    navigate(q ? `/jobs?keyword=${encodeURIComponent(q)}` : '/jobs');
  };
  const scrollRail = (dir) => railRef.current?.scrollBy({ left: dir * 320, behavior: 'smooth' });

  const peopleImg = (
    <img
      src="/hero-people.png"
      alt="Professionals from different careers"
      draggable="false"
      className="hero-people"
      style={d
        ? { position: 'absolute', left: u(PEOPLE.x), width: u(PEOPLE.w), bottom: u(849 - PEOPLE.bottom), height: 'auto', zIndex: 4, pointerEvents: 'none' }
        : { width: '100%', maxWidth: 520, margin: '0 auto', height: 'auto' }}
    />
  );

  return (
    <section
      className="hero-sec relative overflow-hidden"
      style={d ? { height: u(849), marginBottom: '2.5rem' } : { paddingBottom: '1rem' }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .hero-sec { font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
          background:
            radial-gradient(38% 34% at 100% 100%, rgba(250,190,224,.6), transparent 72%),
            radial-gradient(34% 46% at 8% 100%, rgba(196,181,253,.5), transparent 72%),
            radial-gradient(48% 56% at 80% 24%, rgba(150,200,245,.8), transparent 72%),
            linear-gradient(180deg,#F8F4FF 0%,#F0E9FF 70%,#F6E9F8 100%); }
        .hero-sec .hero-people {
  -webkit-mask-image:
    linear-gradient(90deg, transparent 0%, #000 42%, #000 94%, transparent 100%),
    linear-gradient(180deg, transparent 0%, #000 22%, #000 88%, transparent 100%);
  -webkit-mask-composite: source-in;
  mask-image:
    linear-gradient(90deg, transparent 0%, #000 42%, #000 94%, transparent 100%),
    linear-gradient(180deg, transparent 0%, #000 22%, #000 88%, transparent 100%);
  mask-composite: intersect;
}
        .hero-sec .g-violet { background-image: linear-gradient(90deg,#4F23D8,#8B3BF0); -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; color:transparent; }
        .hero-sec .g-pink { background-image: linear-gradient(90deg,#D82A9E,#F0489E); -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; color:transparent; }
        .hero-sec .btn-find { background-image:linear-gradient(90deg,#4F23D8,#7C3AED 55%,#DB2777); box-shadow:0 14px 30px -10px rgba(124,58,237,.7); transition:transform .25s ease; }
        .hero-sec .btn-find:hover { transform:translateY(-2px); }
        .hero-sec .glass { background:rgba(255,255,255,.86); backdrop-filter:blur(10px); -webkit-backdrop-filter:blur(10px); }
        .hero-sec .rail::-webkit-scrollbar { display:none; } .hero-sec .rail { scrollbar-width:none; }
        @keyframes hero-float { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-7px); } }
        .hero-sec .float-a { animation:hero-float 5s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) { .hero-sec .float-a { animation:none; } }

        .hero-sec .chat-launcher { position: fixed; right: 24px; bottom: 92px; z-index: 95; height: 60px; padding: 0 20px 0 10px; gap: 10px; white-space: nowrap; border-radius: 999px; border: 0; cursor: pointer;
  display: flex; align-items: center; justify-content: center; color: #fff;
  .hero-sec .chat-launcher-name { font-weight: 700; font-size: 15px; line-height: 1.1; text-align: left; }
.hero-sec .chat-launcher-name small { display: block; font-weight: 500; font-size: 11px; opacity: .85; }
  background-image: linear-gradient(135deg,#4F23D8,#7C3AED 60%,#DB2777);
  box-shadow: 0 14px 30px -8px rgba(124,58,237,.65);
  animation: launcher-pop .4s cubic-bezier(.2,.8,.2,1) both, launcher-pulse 2.4s ease-out 1s infinite;
  transition: transform .25s ease; }
.hero-sec .chat-launcher:hover { transform: translateY(-3px) scale(1.06); }
.hero-sec .chat-launcher-b { width: 34px; height: 34px; border-radius: 999px; background: #fff; color: #E11D2E;
  display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 18px; }
.hero-sec .chat-launcher-dot { position: absolute; top: 6px; right: 6px; width: 13px; height: 13px; border-radius: 999px; background: #4ADE80; border: 2px solid #fff; }
@keyframes launcher-pop { from { opacity: 0; transform: scale(.6); } to { opacity: 1; transform: none; } }
@keyframes launcher-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(124,58,237,.45), 0 14px 30px -8px rgba(124,58,237,.65); }
  100% { box-shadow: 0 0 0 18px rgba(124,58,237,0), 0 14px 30px -8px rgba(124,58,237,.65); }
}
@media (prefers-reduced-motion: reduce) { .hero-sec .chat-launcher { animation: none; } }
      `}</style>

      {/* ---------- scenery (desktop) ---------- */}
      {d && (
        <>
          {/* dots, top-left */}
          <div style={{ ...box(0, 0, 230, 230), backgroundImage: 'radial-gradient(#C9B8F5 1.6px, transparent 1.8px)', backgroundSize: `${u(18)} ${u(18)}`, opacity: 0.5, WebkitMaskImage: 'radial-gradient(circle at 0 0, #000 20%, transparent 75%)', maskImage: 'radial-gradient(circle at 0 0, #000 20%, transparent 75%)' }} aria-hidden="true" />
          {/* clouds */}
          <div style={{ ...box(1010, 40, 420, 110), background: 'rgba(255,255,255,.75)', borderRadius: '50%', filter: 'blur(18px)' }} aria-hidden="true" />
          <div style={{ ...box(1180, 110, 480, 120), background: 'rgba(255,255,255,.7)', borderRadius: '50%', filter: 'blur(20px)' }} aria-hidden="true" />
          <div style={{ ...box(760, 210, 380, 90), background: 'rgba(255,255,255,.55)', borderRadius: '50%', filter: 'blur(18px)' }} aria-hidden="true" />

          {/* paper plane + arcs */}
          <svg viewBox="0 0 120 90" style={{ ...box(883, 104, 120, 90), zIndex: 5 }} fill="none" aria-hidden="true">
            <path d="M6 82 C 10 44, 52 22, 90 30" stroke="#7C6CF0" strokeWidth="2" strokeLinecap="round" />
            <path d="M104 20 L72 34 L84 40 L88 54 L96 44 L106 50Z" fill="#EDE9FE" stroke="#8B7BF2" strokeWidth="2" strokeLinejoin="round" />
          </svg>
          <svg viewBox="0 0 80 40" style={{ ...box(1188, 166, 80, 40), zIndex: 5 }} fill="none" aria-hidden="true">
            <path d="M4 34 C 24 14, 50 8, 74 8" stroke="#F0489E" strokeWidth="2.4" strokeLinecap="round" />
          </svg>

          {/* soft waves at the bottom */}
          <svg style={{ position: 'absolute', left: 0, bottom: 0, width: '100%', height: u(120), zIndex: 1 }} viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true">
            <defs>
              <linearGradient id="wv1" x1="0" x2="1"><stop offset="0" stopColor="#B9A4F7" stopOpacity=".55" /><stop offset="1" stopColor="#F6A8D4" stopOpacity=".5" /></linearGradient>
              <linearGradient id="wv2" x1="0" x2="1"><stop offset="0" stopColor="#C9B8FA" stopOpacity=".6" /><stop offset="1" stopColor="#F9C5E3" stopOpacity=".55" /></linearGradient>
            </defs>
            <path d="M0 50 C 260 10, 520 20, 800 56 S 1260 96, 1440 40 L1440 120 L0 120Z" fill="url(#wv1)" />
            <path d="M0 76 C 300 40, 560 50, 840 84 S 1260 112, 1440 70 L1440 120 L0 120Z" fill="url(#wv2)" />
          </svg>
        </>
      )}

      <div className={d ? '' : 'relative px-5 pt-6 flex flex-col gap-5'}>

        {/* badge */}
        <div
          style={{ ...box(74, 56, null, 44), ...(d ? { zIndex: 8 } : {}) }}
          className="inline-flex w-fit items-center rounded-full bg-white shadow-[0_8px_24px_-10px_rgba(124,58,237,.35)] border border-white"
        >
          <span style={d ? { width: u(34), height: u(34), marginLeft: u(9) } : { width: 28, height: 28, marginLeft: 6 }} className="rounded-full bg-gradient-to-br from-[#FDBA2D] to-[#F59E0B] flex items-center justify-center shrink-0">
            <svg viewBox="0 0 24 24" style={{ width: '60%', height: '60%' }} fill="#fff" aria-hidden="true"><path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" /></svg>
          </span>
          <span style={{ ...fs(19), margin: d ? `0 ${u(14)} 0 ${u(11)}` : '0 10px 0 8px' }} className="font-bold text-[#0F0A2E] text-sm whitespace-nowrap">India&rsquo;s Smarter Job Portal</span>
          <span style={d ? { ...fs(17), height: u(40), padding: `0 ${u(16)}`, marginRight: u(2) } : { height: 32, padding: '0 12px' }} className="inline-flex items-center font-bold text-white rounded-full text-xs whitespace-nowrap bg-gradient-to-r from-[#4338CA] to-[#6D28D9]">🚀 100% Free</span>
        </div>

        {/* headline */}
        <h1
          style={{ ...box(74, 112, 780, null), ...fs(73, 74), letterSpacing: '-0.035em', whiteSpace: d ? 'nowrap' : 'normal', zIndex: 8 }}
          className="font-extrabold text-[#0B0A1F] text-[2.5rem] sm:text-6xl leading-[1.05]"
        >
          Find Your Next Move.
          <span className="block"><span className="g-violet">Build Your</span> <span className="g-pink">Future.</span></span>
        </h1>

        {d && (
          <svg viewBox="0 0 255 24" style={{ ...box(493, 254, 255, 24), zIndex: 8 }} fill="none" aria-hidden="true">
            <path d="M4 20 C 70 6, 170 4, 251 8" stroke="#E0399E" strokeWidth="4" strokeLinecap="round" />
          </svg>
        )}

        {/* paragraph */}
        <p style={{ ...box(74, 292, 590, null), ...fs(19.5, 27), zIndex: 8 }} className="text-[#3B3556] text-base leading-relaxed max-w-[560px]">
          Your next opportunity could be closer than you think. Explore thousands of career possibilities, discover jobs matching your skills and connect with employers.
        </p>

        {/* checks */}
        <ul style={{ ...box(74, 398, 560, 30), ...(d ? { gap: u(28), zIndex: 8 } : {}) }} className="flex flex-wrap items-center gap-x-5 gap-y-2">
          {CHECKS.map((c) => (
            <li key={c} style={d ? { gap: u(10), ...fs(18) } : {}} className="inline-flex items-center gap-2 text-sm font-semibold text-[#1E0F3D]">
              <span style={d ? { width: u(26), height: u(26) } : { width: 20, height: 20 }} className="rounded-full bg-gradient-to-br from-[#5B2BE0] to-[#8B3BF0] text-white flex items-center justify-center shrink-0">
                <svg viewBox="0 0 24 24" style={{ width: '62%', height: '62%' }} fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
              </span>
              {c}
            </li>
          ))}
        </ul>

        {/* the group of professionals */}
        {peopleImg}

        {/* search bar */}
        <form
          onSubmit={onSearch}
          style={{ ...box(74, 466, 971, 76), ...(d ? { paddingLeft: u(30), paddingRight: u(13), zIndex: 10 } : {}) }}
          className="flex flex-col lg:flex-row lg:items-center bg-white/95 rounded-3xl lg:rounded-full shadow-[0_20px_50px_-24px_rgba(76,29,149,.45)] border border-white p-3 gap-2 lg:gap-0"
        >
        <label className="relative flex items-center" style={d ? { width: u(288), gap: u(14) } : { gap: 10 }}>
  <svg viewBox="0 0 24 24" style={d ? { width: u(30), height: u(30) } : { width: 20, height: 20 }} className="text-[#1E0F3D] shrink-0" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
  <input
    type="text" value={keyword}
    onChange={onKeywordChange || ((e) => setKeyword(e.target.value))}
    onBlur={onKeywordBlur} autoComplete="off"
    placeholder="Job title, skills or keywords" aria-label="Job title, skills or keywords"
    style={fs(18)} className="flex-1 min-w-0 bg-transparent text-[15px] text-[#1E0F3D] placeholder:text-[#4B4766] focus:outline-none"
  />
  {keywordSuggestions.length > 0 && <SugList items={keywordSuggestions} onPick={onKeywordPick} />}
</label>
{d && <span style={{ width: 1, height: u(44) }} className="bg-[#1E0F3D]/20 shrink-0" aria-hidden="true" />}
<label className="relative flex items-center" style={d ? { width: u(201), paddingLeft: u(46), gap: u(14) } : { gap: 10 }}>
  <svg viewBox="0 0 24 24" style={d ? { width: u(28), height: u(28) } : { width: 20, height: 20 }} className="text-[#6D28D9] shrink-0" fill="currentColor" aria-hidden="true"><path d="M12 2a7 7 0 00-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 00-7-7zm0 9.5A2.5 2.5 0 119.5 9 2.5 2.5 0 0112 11.5z" /></svg>
  <input
    type="text" value={location}
    onChange={onLocationChange || ((e) => setLocation(e.target.value))}
    onBlur={onLocationBlur} autoComplete="off"
    placeholder="Location" aria-label="Location"
    style={fs(18)} className="flex-1 min-w-0 bg-transparent font-semibold text-[15px] text-[#1E0F3D] placeholder:text-[#1E0F3D] focus:outline-none"
  />
  {d && <Chev size={14} />}
  {locationSuggestions.length > 0 && <SugList items={locationSuggestions} onPick={onLocationPick} />}
</label>
          {d && <span style={{ width: 1, height: u(44) }} className="bg-[#1E0F3D]/20 shrink-0" aria-hidden="true" />}
          <div ref={indRef} className="relative flex items-center" style={d ? { width: u(202), gap: u(14) } : { gap: 10 }}>
            <button
              type="button"
              onClick={() => setIndOpen((o) => !o)}
              aria-haspopup="listbox" aria-expanded={indOpen} aria-label="Industry"
              className="w-full flex items-center font-semibold text-[15px] text-[#1E0F3D] focus:outline-none"
              style={d ? { ...fs(18), paddingLeft: u(46), paddingRight: u(24), gap: u(14) } : { gap: 10 }}
            >
              <svg viewBox="0 0 24 24" style={d ? { width: u(32), height: u(32) } : { width: 20, height: 20 }} className="text-[#1E0F3D] shrink-0" fill="currentColor" aria-hidden="true"><path d="M9 4h6a1 1 0 011 1v2h4a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V9a2 2 0 012-2h4V5a1 1 0 011-1zm1 3h4V6h-4zM2 13h20v-1H2z" /></svg>
              <span className="flex-1 min-w-0 truncate text-left">{indLabel}</span>
              <span style={{ display: 'inline-flex', transform: indOpen ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}><Chev size={d ? 14 : 12} /></span>
            </button>

            {indOpen && (
              <ul
                role="listbox"
                style={{ position: 'absolute', top: 'calc(100% + 16px)', left: 0, width: 300, maxHeight: 300, overflowY: 'auto', background: '#fff', borderRadius: 18, border: '1px solid #EDE4FB', boxShadow: '0 24px 50px -16px rgba(76,29,149,.45)', padding: 8, zIndex: 60, textAlign: 'left' }}
              >
                {[{ slug: '', name: 'All industries' }, ...departments].map((x) => {
                  const on = industry === x.slug;
                  return (
                    <li
                      key={x.slug || 'all'}
                      role="option" aria-selected={on}
                      onMouseDown={() => { setIndustry(x.slug); setIndOpen(false); }}
                      className={`flex items-center justify-between gap-3 px-3.5 py-2.5 rounded-xl text-sm cursor-pointer transition ${on ? 'bg-[#F3F0FF] text-[#4F23D8] font-bold' : 'text-[#1E0F3D] font-medium hover:bg-[#F3F0FF] hover:text-[#4F23D8]'}`}
                    >
                      <span className="truncate">{x.name}</span>
                      {on && (
                        <svg viewBox="0 0 24 24" style={{ width: 16, height: 16 }} fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
          {d && <span style={{ width: 1, height: u(44) }} className="bg-[#1E0F3D]/20 shrink-0" aria-hidden="true" />}
          <button
            type="submit"
            style={d ? { ...fs(21), width: u(205), height: u(60), gap: u(12), marginLeft: u(29) } : {}}
            className="btn-find shrink-0 inline-flex items-center justify-center text-white font-bold text-base rounded-full px-6 py-3 gap-2"
          >
            Find Jobs
            <svg viewBox="0 0 24 24" style={d ? { width: u(26), height: u(26) } : { width: 20, height: 20 }} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
          </button>
        </form>

               {/* trust stats */}
        <div
          className="glass rounded-[28px] border border-white/70 shadow-[0_20px_50px_-30px_rgba(76,29,149,.4)]"
          style={{
            ...box(72, 590, 1280, 140),
            zIndex: 9,
            ...(d
              ? { borderRadius: u(28), display: 'flex', alignItems: 'center', gap: u(16), padding: `0 ${u(24)}` }
              : { padding: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }),
          }}
        >
          {HERO_STATS.map((s) => (
            <div
              key={s.small}
              className="flex-1 flex items-center bg-white shadow-[0_8px_20px_-12px_rgba(76,29,149,.35)] hover:-translate-y-1 transition"
              style={d ? { height: u(92), padding: `0 ${u(20)}`, gap: u(16), borderRadius: u(20) } : { padding: 12, gap: 10, borderRadius: 16 }}
            >
              <span
                className="shrink-0 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#EDE9FE] to-[#FCE7F3]"
                style={d ? { width: u(54), height: u(54), fontSize: u(28) } : { width: 40, height: 40, fontSize: 20 }}
                aria-hidden="true"
              >
                {s.emoji}
              </span>
              <div>
                <p style={fs(27, 30)} className="font-extrabold text-[#0F0A2E] leading-tight text-lg">{s.big}</p>
                <p style={fs(15, 18)} className="font-semibold text-[#4B4766] text-xs">{s.small}</p>
              </div>
            </div>
          ))}
        </div>
        {d && (
          <>
            <button type="button" onClick={() => scrollRail(-1)} aria-label="Previous jobs" style={{ ...box(41, 648, 52, 52), zIndex: 10 }} className="glass rounded-full shadow-lg flex items-center justify-center text-[#4F23D8]">
              <svg viewBox="0 0 24 24" style={{ width: u(24), height: u(24) }} fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>
            </button>
            <button type="button" onClick={() => scrollRail(1)} aria-label="Next jobs" style={{ ...box(1332, 648, 52, 52), zIndex: 10 }} className="glass rounded-full shadow-lg flex items-center justify-center text-[#4F23D8]">
              <svg viewBox="0 0 24 24" style={{ width: u(24), height: u(24) }} fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
            </button>
          </>
        )}

        {registerPreset && (
  <div
    style={d
      ? { position: 'absolute', top: u(110), right: u(17), width: 380, zIndex: 40 }
      : { width: '100%' }}
  >
    <RegisterChat embedded preset={registerPreset} onClose={() => setRegisterPreset(null)} />
  </div>
)}

        {/* assistant card */}
      {chatOpen && !registerPreset && (
          <div
            style={{ ...box(1377, 100, 278, chatMin ? 61 : 476), zIndex: 30, ...(d ? { transform: 'scale(1.5)', transformOrigin: 'top right' } : {}) }}
            className="glass rounded-[24px] border border-white/80 shadow-[0_40px_80px_-30px_rgba(76,29,149,.5)] w-full"
          >
            <div
              style={{ height: d ? u(61) : 60, borderRadius: d ? `${u(24)} ${u(24)} 0 0` : '24px 24px 0 0', backgroundImage: 'linear-gradient(90deg,#4F23D8,#7C3AED 60%,#A22FC9)', ...(d ? { gap: u(10), padding: `0 ${u(14)}` } : {}) }}
              className="flex items-center text-white px-4 gap-3"
            >
              <span style={d ? { width: u(36), height: u(36), fontSize: u(19) } : {}} className="relative w-9 h-9 rounded-full bg-white text-[#E11D2E] flex items-center justify-center font-extrabold shrink-0">
                B<span className="absolute bottom-0 right-0 w-2 h-2 rounded-full bg-[#4ADE80] border-2 border-white" />
              </span>
              <div className="flex-1 min-w-0">
                <p style={fs(15)} className="font-bold leading-tight text-sm">PlanB Assistant</p>
                <p style={fs(11.5)} className="text-xs text-white/85">Your AI Career Guide</p>
              </div>
              <button type="button" onClick={() => setChatMin((v) => !v)} aria-label={chatMin ? 'Expand assistant' : 'Minimise assistant'} style={fs(22)} className="w-6 h-6 flex items-center justify-center leading-none hover:bg-white/15 rounded-full">&minus;</button>
              <button type="button" onClick={() => setChatOpen(false)} aria-label="Close assistant" style={fs(22)} className="w-6 h-6 flex items-center justify-center leading-none hover:bg-white/15 rounded-full">&times;</button>
            </div>

            {!chatMin && (
              <div className={d ? '' : 'p-4'}>
                <div style={d ? { position: 'absolute', left: u(16), top: u(95), width: u(129), padding: `${u(10)} ${u(12)}`, ...fs(14.5, 23) } : {}} className="bg-white rounded-2xl shadow-[0_8px_24px_-12px_rgba(124,58,237,.35)] px-4 py-3 text-[14px] text-[#1E0F3D] max-w-[62%] mb-3">
                  <p className="font-medium">Hi! <span aria-hidden="true">👋</span></p>
                  <p className="font-medium">What are you looking for today?</p>
                </div>
              <div
  className="float-a"
  style={d ? { position: 'absolute', left: u(160), top: u(72), width: u(110) } : { display: 'none' }}
>
  <Robot />
</div>

                <ul style={d ? { position: 'absolute', left: u(15), top: u(215), width: u(246), display: 'flex', flexDirection: 'column', gap: u(3) } : {}} className={d ? '' : 'space-y-2'}>
                  {CHAT_OPTIONS.map((o) => (
                  <li key={o.label}>
  {o.preset && !isLoggedIn ? (
    <button
      type="button"
      onClick={() => setRegisterPreset(o.preset)}
      style={d ? { height: u(38), padding: `0 ${u(12)}`, gap: u(12), ...fs(15), whiteSpace: 'nowrap' } : {}}
      className="w-full flex items-center gap-3 bg-[#F3F0FF] rounded-xl px-3.5 py-2.5 text-[14px] font-semibold text-[#0F0A2E] hover:bg-[#EAE3FF] transition text-left"
    >
      <span style={d ? { width: u(26), fontSize: u(20) } : {}} className="w-6 text-center text-lg" aria-hidden="true">{o.emoji}</span>
      <span className="flex-1">{o.label}</span>
      <svg viewBox="0 0 24 24" style={d ? { width: u(15), height: u(15) } : { width: 15, height: 15 }} className="text-[#4F23D8]" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
    </button>
  ) : (
    <Link
      to={o.to}
      style={d ? { height: u(38), padding: `0 ${u(12)}`, gap: u(12), ...fs(15), whiteSpace: 'nowrap' } : {}}
      className="flex items-center gap-3 bg-[#F3F0FF] rounded-xl px-3.5 py-2.5 text-[14px] font-semibold text-[#0F0A2E] hover:bg-[#EAE3FF] transition"
    >
      <span style={d ? { width: u(26), fontSize: u(20) } : {}} className="w-6 text-center text-lg" aria-hidden="true">{o.emoji}</span>
      <span className="flex-1">{o.label}</span>
      <svg viewBox="0 0 24 24" style={d ? { width: u(15), height: u(15) } : { width: 15, height: 15 }} className="text-[#4F23D8]" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
    </Link>
  )}
</li>
                  ))}
                </ul>

                <form
                  onSubmit={sendMsg}
                  style={d ? { position: 'absolute', left: u(15), top: u(430), width: u(250), height: u(38), paddingLeft: u(14), paddingRight: u(3) } : {}}
                  className="mt-3 flex items-center bg-white rounded-full border border-purple-100 pl-4 pr-1.5 py-1.5"
                >
                  <input
                    type="text" value={msg} onChange={(e) => setMsg(e.target.value)}
                    placeholder="Type your message..." aria-label="Type your message"
                    style={fs(14)} className="flex-1 min-w-0 bg-transparent text-sm text-[#1E0F3D] placeholder:text-[#4B4766] focus:outline-none"
                  />
                  <button type="submit" aria-label="Send" style={{ ...(d ? { width: u(32), height: u(32) } : {}), backgroundImage: 'linear-gradient(135deg,#4F23D8,#7C3AED)' }} className="w-8 h-8 rounded-full flex items-center justify-center text-white shrink-0">
                    <svg viewBox="0 0 24 24" style={d ? { width: u(16), height: u(16) } : { width: 16, height: 16 }} fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                  </button>
                </form>
              </div>
            )}
          </div>
        )}

        {/* icon to reopen the assistant after it is closed */}
        {!chatOpen && !registerPreset && (
          <button
            type="button"
            aria-label="Open PlanB Assistant"
            onClick={() => { setChatOpen(true); setChatMin(false); }}
            className="chat-launcher"
            style={d ? { position: 'absolute', top: u(55), right: u(40), left: 'auto', bottom: 'auto', height: u(66), zIndex: 30 } : undefined}
          >
            <span className="chat-launcher-b">B</span>
            <span className="chat-launcher-name">
              PlanB Assistant
            </span>
            <span className="chat-launcher-dot" />
          </button>
        )}
      </div>
    </section>
  );
}